import validations from 'vee-validate/dist/locale/es.json'

export default {
  validations,
  commons: {
    save: 'Guardar',
    edit: 'Editar',
    saveAndContinue: 'Guardar y Continuar',
    send: 'Enviar',
    cancel: 'Cancelar',
    close: 'Cerrar',
    back: 'Volver',
    previous: 'Anterior',
    continue: 'Continuar',
    start: 'Comenzar',
    add: 'Añadir',
    omit: 'Omitir',
    finder: {
      placeholder:
        'Escribe al menos {0} caracteres y aguarda para ver los resultados...',
    },
    table: {
      noData: 'No hay datos.',
    },
    skillOrigins: {
      experience: 'Experiencia',
      questionary: 'Cuestionario',
    },
    genders: {
      male: 'Masculino',
      female: 'Femenino',
      others: 'Otros',
      notSpecified: 'Prefiero no\ndecirlo',
    },
  },
  components: {
    skills: {
      searchSkills: {
        suggestDescription: '¿No ves lo que estás buscando?',
        suggestAction: 'Sugerir una Habilidad',
      },
      modalSuggestSkill: {
        title: 'Sugerir una habilidad',
        confirmation: '¡Listo! Se envió la sugerencia de habilidad.',
        description:
          'Escribe una palabra simple o compuesta. Ej: archivar documentos',
      },
      freeSkills: {
        title: '¿Quieres añadir más habilidades?',
        instruction: 'Ingrésalas aquí directamente.',
        note:
          'Nota: Escribe una palabra simple o compuesta. Ej: archivar documentos',
      },
      modalSkillDetail: {
        title: 'Detalle habilidad',
        fields: {
          name: 'Nombre',
          description: 'Descripción',
          isco: 'ISCO',
          reusability: 'Reusabilidad',
          type: 'Tipo',
          essentiality: 'Esencialidad',
        },
      },
    },
    searchEngine: {
      addNew: '¿Tienes otro Cargo? Ingrésalo',
      empty: {
        message:
          '¡Ups! No se encontraron sugerencias para tu búsqueda. Te recomendamos:',
        detail1:
          'Comprueba que todas las palabras estén escritas correctamente',
        detail2: 'Intenta con diferentes palabras clave',
        detail3: 'Utiliza palabras claves más generales',
      },
      groups: {
        occupations: {
          byTitle: 'Resultados con "{0}"...',
          byLabels: 'Otras ocupaciones similares a lo que estás buscando...',
        },
        skills: {
          byTitle: 'Resultados con "{0}"...',
          byLabels: 'Otras habilidades similares a lo que estás buscando...',
        },
      },
    },
    addFreeSkillsWithRecommendations: {
      title: 'Reconoce tus habilidades ({0})',
      subtitle:
        'Te recomendamos incluir todas las habilidades que hayas adquirido durante tu experiencia',
      suggesDescription: 'Sugerencias basadas en [por definir]:',
    },
  },
  api: {
    errors: {
      Auth: {
        form: {
          error: {
            invalid:
              'Su correo electrónico y su contraseña no coinciden. Inténtelo de nuevo.',
            blockedCompanyDemo:
              'Tu periodo de prueba ha finalizado. Para mayor información, por favor comuníquese con nosotros: contacto@relink.cl',
            deactivatedCompany:
              'La compañía a la que perteneces fue desactivada',
            blocked:
              'Su cuenta ha sido deshabilitada. Para mayor información comuníquese con nosotros: contacto@relink.cl.',
            password: { provide: 'Debes ingresar tu contraseña' },
            email: {
              provide: 'Debes ingresar tu correo electronico',
              taken: 'Email ya está en uso',
            },
          },
        },
      },
    },
  },
  dashboard: {
    title: '¡Hola, {0}!',
    welcome: '¡Bienvenid@ nuevamente!',
    description: {
      completed: {
        company:
          'Bienvenido/a al panel privado. Aquí podrás administrar y monitorear la participación de tus colaboradores en la plataforma.',
        public:
          'Te damos la bienvenida a Relink, una plataforma de orientación laboral, que busca conectar a las personas con las oportunidades laborales de futuro, a partir de sus experiencias y habilidades.',
        relink: 'Esta página muestra una descripción general tu cuenta Relink.',
        adminUnemployed:
          'Bienvenido/a al panel privado. Aquí podrás administrar y monitorear la participación de tus colaboradores en la plataforma.',
      },
      incomplete: {
        company:
          'Bienvenido/a al panel privado. Aquí podrás administrar y monitorear la participación de tus colaboradores en la plataforma.',
        public:
          'Te damos la bienvenida a Relink, una plataforma de orientación laboral, que busca conectar a las personas con las oportunidades laborales del futuro, a partir de sus experiencias y habilidades. Para poder identificar cuáles son las nuevas ocupaciones que se ajustan a tu perfil, por favor responde una serie de preguntas acerca de tu formación y tu experiencia laboral que nos ayudarán a identificar tus habilidades.',
        relink: 'Esta página muestra una descripción general tu cuenta Relink.',
        adminUnemployed:
          'Bienvenido/a al panel privado. Aquí podrás administrar y monitorear la participación de tus colaboradores en la plataforma.',
      },
    },
    incomplete: {
      missingSteps: {
        company:
          'Para empezar: te falta 1 tarea. | Para empezar: te faltan {count} tareas.',
        default:
          'Para obtener tus oportunidades: te falta 1 tarea. | Para obtener tus oportunidades: te faltan {count} tareas.',
      },
      message: 'Completa tu perfil.',
      progress: 'Estado de Avance: <span class="highlighted">{0}%</span>',
      tests: '¡Queremos saber más sobre ti!',
      titles: {
        profile: 'Completa tus datos personales',
        experience: 'Añade experiencias a tu perfil',
        experienceEmployee: 'Ingresa tu experiencia laboral actual',
        education: 'Ingresa una Experiencia Formativa',
        work: 'Ingresa una Experiencia Laboral',
        tests: 'Realiza el test de habilidades',
        picture: 'Agrega una foto de perfil',
        invitation: 'Invita a tus trabajadores',
        occupation: 'Agregar una nueva ocupación',
        announcement: 'Agregar una nueva ocupación requerida por tu Piloto',
        project: 'Crear un nuevo proyecto',
      },
      buttons: {
        profile: 'Ingresa tus datos',
        experience: 'Añadir experiencias',
        education: 'Añadir Experiencia',
        work: 'Añadir Experiencia',
        tests: 'Comienza el test',
        picture: 'Agregar Foto',
        invitation: 'Enviar invitación',
        occupation: 'Agregar una ocupación',
        announcement: 'Agregar una ocupación',
        project: 'Crear proyecto',
      },
      tooltips: {
        experience:
          'Registra experiencias laborales, formativas y/u otras, cuyo aprendizaje consideres que haya sido relevante para tu desarrollo profesional.',
      },
    },
    complete: {
      match:
        'Porcentaje de </br> coincidencia: <span class="highlighted">{0}%</span>',
      skills:
        'Cuentas con <span class="highlighted">{0}</span> de {1} habilidades requeridas',
      companySkills:
        'Cuentas con <span class="highlighted">{0}</span> potenciales candidatos al puesto',
      companySubHeader: 'Selecciona el match perfecto a reconvertir para:',
      skillsInventory:
        '<span class="highlighted">{0}</span> trabajadores ya han ingresado sus experiencias',
      buttons: {
        opportunity: 'Ver oportunidad',
      },
    },
    relink: {
      singleInfo: [
        {
          title: 'Solicitud de reunión',
          icon: '/img/icons/calendar.svg',
          url: '/solicitudes/reuniones',
          description: '(Rango de 30 días)',
        },
        {
          title: 'Personas invitadas',
          icon: '/img/icons/invitation.svg',
          description: '(Rango de 30 días)',
        },
        {
          title: 'Empresas creadas',
          icon: '/img/icons/company.svg',
          url: '/empresas-piloto',
          description: '(Rango de 30 días)',
        },
      ],
    },
    revalidate: {
      firstSection:
        '¡Hola! Debido a las mejoras que hemos realizado a nuestro algoritmo, puede que tengas que validar nuevamente habilidades de experiencias que hayas ingresado anteriormente en la plataforma. Te invitamos a revisar si tienes alguna pendiente, las cuales podrás reconocer con la etiqueta ',
      highlighted: '"Por Validar".',
      button: 'Ir a mis experiencias',
    },
    employee: {
      skillsInventory: {
        title: 'Mi Inventario de Habilidades',
        subtitle:
          'Con esta sección podrás conocer todas las habilidades que dispones a partir de tus experiencias identificadas. ',
        cards: {
          mySkillsInventory: {
            title: 'Mi Inventario de Habilidades',
            buttonText: 'Ver mi inventario',
          },
          moreSkills: {
            title: 'Suma más habilidades',
            buttonText: 'Añadir más experiencias',
          },
        },
      },
      opportunities: {
        title: 'Mis Oportunidades',
        subtitle:
          'Te presentamos aquellas ocupaciones que tienen mayor coincidencia con tu perfil laboral, considerando las experiencias y las habilidades que identificaste en la plataforma.',
        emptyOpportunitiesMessage:
          'Aún no encontramos tu match perfecto :( ¡Pero no desanimes! Continúa registrando experiencias para optar a nuevas oportunidades de reconversión.',
      },
      updatePasswordModal: {
        titleModal: 'Recomendación',
        titleText: '¿Qué tal si actualizas tu contraseña?',
        contentText:
          'Te recomendamos que actualices tu contraseña para garantizar la seguridad de tu cuenta. Puedes realizar este cambio en la sección "Mi perfil".',
        closeButton: 'Ignorar',
        acceptButton: 'Entendido',
      },
      questionary: {
        description: {
          isFinish:
            'Te presentamos los resultados de tu cuestionario, los cuales te ayudarán a alcanzar tu máximo potencial.',
          isNotFinish:
            'Descubre tus habilidades al responder las siguientes preguntas.',
        },
        action: {
          isPending: 'Comenzar',
          isFinish: 'Ver mis resultados',
          isNotFinish: 'Continuar',
        },
      },
      activeQuestionary: {
        title: 'Perfil meta',
        description:
          'Descubre tus habilidades respondiendo las siguientes preguntas',
      },
      modelQuestionary: {
        title: 'Empleabilidad y productividad',
        description:
          'Descubre diferentes conjuntos de habilidades específicos para tu perfil laboral',
      },
      cardInventory: {
        title: 'Mi Inventario',
        description:
          'Aquí encontraras tus habilidades, tanto de cuestionarios como de experiencias.',
        buttonAction: 'Ver mi inventario',
      },
      cardAddSkills: {
        title: 'Suma más habilidades',
        description: 'Aquí podrás sumar experiencias laborales o formativas.',
        buttonAction: 'Añadir más experiencias',
      },
      withOutProjectState: {
        title: 'Actualmente no tienes proyecto asignado',
        description:
          'Si quieres ingresar nuevas experiencias o revisar las ya registradas, ingresa a:',
        action: 'Ir a mis experiencias',
      },
    },
    projects: {
      alertMessage: 'Para comenzar te falta 1 tarea',
      filters: {
        text: {
          placeholder: 'Buscar proyecto',
        },
        status: {
          placeholder: 'Estado de proyecto',
          options: {
            active: 'En curso',
            close: 'Finalizado',
          },
        },
      },
      downloadReport: {
        title: 'Descargar',
        companyDataReport: {
          title: 'Datos de trabajadores',
          subtitle: 'Empresa',
        },
        executiveReport: {
          title: 'Reporte ejecutivo',
          subtitle: 'Empresa',
        },
        export: {
          title: 'Exportar reporte',
        },
      },
    },
    privacyPolicy: {
      header: 'Actualización de Política de Privacidad y Tratamiento de Datos',
      title: '¡Mantenemos tus datos seguros!',
      footer:
        '¡Hola! Queremos informarte sobre la actualización que hemos realizado a nuestra <a class="privacy-link" target="_blank" href="politicas-de-privacidad/">política de privacidad</a> y <a target="_blank" class="privacy-link" href="politica-tratamiento-datos/">tratamiento de datos</a>. <b>Tu confianza es fundamental, por eso trabajamos para garantizar la protección de tu información en nuestro sitio web.</b>',
      cancel: 'Salir',
      cta: 'Entendido',
    },
  },
  invitation: {
    individual: {
      form: {
        options: {
          languages: 'Selecciona un idioma',
          situationLaboral: 'Selecciona una situación laboral',
        },
      },
    },
    custom_message: {
      title: 'Personaliza el mensaje de invitación',
      subtitle: 'Mensaje personalizado:',
      placeholder:
        '¿Qúe mensaje personal, le gustaría añadir al contenido de su correo de invitación?',
      preview: 'Previsualizar',
      save: 'Guardar',
    },
  },
  experience: {
    suggestedSkillsComponent: {
      titleRegister: 'Sugerencias basadas en tu experiencia:',
      titleDetail: 'Sugerencias aprendidas en tu experiencia:',
      subtitle: {
        start: 'Tienes ',
        end: ' habilidades sugeridas para seleccionar',
      },
      empty: {
        title:
          'Ya reconociste todas las habilidades sugeridas para esta experiencia',
        subtitle:
          '¡Te invitamos a seguir ingresando habilidades desde el buscador que encuentras abajo!',
      },
      viewMore: 'Ver {quantitySkillNotVisible} más',
      viewLess: 'Ver menos',
    },
    yourSkill: {
      title: 'Tus habilidades adquiridas',
      messages: {
        skillNoRecords:
          '¡Todo listo! Esta experiencia no tiene ningún conocimiento, capacidad o habilidad pendiente para poder registrar ;)',
        differenceSkill: 'Tienes {differenceSkill} habilidad(es) sin validar.',
        revalidateSkill:
          'Tienes {differenceSkill} habilidad(es) pendientes de validación.',
      },
    },
    yourSkillOtherExperience: {
      title: 'Tus habilidades adquiridas',
      messages: {
        skillNoRecords:
          '¡Todo listo! Esta experiencia no tiene ningún conocimiento, capacidad o habilidad pendiente para poder registrar ;)',
        differenceSkill: 'Tienes menos de {minSkills} habilidad(es) validadas.',
        revalidateSkill:
          'Tienes {differenceSkill} habilidad(es) pendientes de validación.',
      },
    },
    title: 'Mis experiencias',
    table: {
      fields: {
        skillPossed: 'Habilidades adquiridas',
        status: 'Estatus de registro',
        detail: 'Detalle',
        experience: 'Experiencia',
        organization: 'Organización',
        acquiredSkills: 'Habilidades adquiridas',
        someField: 'Algún campo',
      },
    },
    messages: {
      status: {
        all: 'Todos',
        completed: 'Completo',
        uncompleted: 'Incompleto',
        forValidate: 'Por Validar',
      },
      noRecord: {
        title: '¡Hey!',
        alert: '¡No tienes experiencias registradas!',
        description:
          'Si no ingresas tus experiencias, NO podrás acceder a nuevas oportunidades de reconversión :(',
      },
    },
    description:
      'En esta sección podrás ver y añadir tus experiencias laborales, formativas u otras.',
    detail: {
      title: '',
      description:
        'Revisa todas las habilidades que aprendiste en tu experiencia.',
      buttons: {
        downloadReport: 'Descargar reporte',
      },
      actions: {
        delete: 'Eliminar experiencia',
        deletePrompt: '¿Estás seguro de querer eliminar esta experiencia?',
        edit: 'Editar experiencia',
        deleteNotification: 'Experiencia eliminada con éxito',
      },
    },
    add: {
      title: 'Ingresa una nueva experiencia',
      description:
        'Registra una nueva experiencia formativa, laboral o de otro tipo:',
    },
    wizard: {
      previous: 'Anterior',
      next: 'Continuar',
      newExperience: 'Registrar Experiencia',
      finish: 'Finalizar experiencia',
      steps: {
        form: {
          label: 'Ingresa tus datos',
        },
        skills: {
          label: 'Reconoce tus habilidades',
        },
        finished: {
          label: '¡Listo!',
        },
      },
    },
    laboral: {
      title: 'Experiencia laboral',
      form: {
        header: 'Ingresa los datos de tu nueva experiencia laboral:',
        present: 'Al presente',
        endDate: 'Fecha finalización',
        startDate: 'Fecha inicio',
        companyBusinnesArea: 'Rubro de la empresa',
        company: 'Compañía',
        occupation: 'Cargo',
        customOccupation: 'Especifica, por favor:',
        currentRole: 'Actualmente tengo este cargo',
        notificationChangeRole: 'Se finalizará el puesto actual: {0} en {1}',
        placeholder: {
          selectedBusinessAreas: 'Selecciona un rubro de empresa',
          selectedOccupation: 'Selecciona un cargo',
        },
        success: {
          noSkills:
            '<p><b>Experiencia laboral registrada sin habilidades</b> <br> El cargo seleccionado no contaba con habilidades.</p>',
          skills:
            '<p><b>Experiencia laboral registrada parcialmente</b> <br> A continuación deberás seleccionar las habilidades que posees del cargo seleccionado.</p>',
        },
      },
      add: {
        title: 'Nueva experiencia laboral',
        description:
          'Sigue el paso a paso para ingresar tu experiencia y reconocer tus habilidades.',
      },
    },
    educational: {
      title: 'Experiencia formativa',
      form: {
        header: 'Ingresa los datos de tu nueva experiencia formativa:',
        educationalType: 'Tipo de estudio',
        educationalCarrer: 'Título / Carrera',
        searchOccupation: {
          addNew: '¿Tienes otro Título / Carrera? Ingrésalo',
        },
        educationalArea: 'Área de estudio',
        educationalSpecialty: 'Especialidad / Mención',
        educationalStatus: 'Estado',
        studyLocation: 'Lugar de estudios',
        placeholder: {
          selectedEducationalType: 'Selecciona un tipo de estudio',
          selectedEducationalCarrer: 'Selecciona un titulo o carrera',
          addEducationalTitle: 'Ingresa el nombre del estudio realizado',
          addEducationalCarrer: 'Agregar carrera',
          selectedEducationalArea: 'Selecciona una área de estudio',
          selectedEducationalSpecialty: 'Selecciona una especialidad',
          selectedEducationalStatus: 'Selecciona un estado',
          studyLocation: 'Escribe un lugar de estudios',
          addStudyLocation: 'Agregar lugar de estudios',
        },
        success: {
          noSkills:
            '<p><b>Experiencia formativa registrada sin habilidades</b> <br> El área seleccionada no contaba con habilidades.</p>',
          skills:
            '<p><b>Experiencia formativa registrada parcialmente</b> <br> A continuación deberás seleccionar las habilidades que posees del área seleccionada.</p>',
        },
      },
      add: {
        title: 'Nueva experiencia formativa',
        description:
          'Sigue el paso a paso para ingresar tu experiencia y reconocer tus habilidades.',
        stepOne: {
          title: 'Ingresa los datos de tu experiencia formativa:',
        },
        stepTwo: {
          title: 'Reconoce tus habilidades',
          subtitle:
            'Selecciona todas las habilidades que permitan demostrar tu dominio en la experiencia ingresada.',
        },
      },
    },
    other: {
      title: 'Otras experiencias',
    },
    others: {
      title: 'Nueva experiencia',
      form: {
        header: 'Ingresa los datos de tu experiencia:',
        detail: 'Detalle de experiencia',
        startDate: 'Fecha de inicio:',
        endDate: 'Fecha de finalización:',
        placeholder: {
          detail: 'Ej. Cuidado adulto mayor',
        },
        success: {
          noSkills:
            '<p><b>Experiencia registrada sin habilidades</b> <br> El área seleccionada no contaba con habilidades.</p>',
          skills:
            '<p><b>Experiencia registrada parcialmente</b> <br> A continuación deberás seleccionar las habilidades que posees del área seleccionada.</p>',
        },
      },
      add: {
        title: 'Nueva experiencia',
        description:
          'Sigue el paso a paso para ingresar tu experiencia y reconocer tus habilidades.',
      },
    },
    button: {
      new: {
        experienceWork: 'Experiencia laboral',
        experienceEducational: 'Experiencia formativa',
        experienceOther: 'Otras experiencias',
        experienceWorkHover:
          'Queremos conocer el cargo u ocupación en el que te has desempeñado.',
        experienceEducationalHover:
          'Queremos conocer tus experiencias educativas, tales como cursos, diplomados, maestrías, etc.',
        experienceOtherHover:
          'Queremos conocer otras experiencias cuyo aprendizaje consideres que ha sido relevante para tu desarrollo profesional',
        experience: 'Agregar nueva experiencia',
      },
    },
    register: {
      confirmExperienceTitle: 'Finalizar registro de experiencia',
      allQuestionsNotAnswered:
        'No has terminado de registrar tus habilidades, puedes continuar luego desde la sección mi experiencia. Aún así, ¿Quieres salir de esta pantalla?',
      allQuestionsAnswered:
        'Estas a punto de registrar una nueva experiencia y las habilidades que aprendiste.',
      confirmExperienceSave: 'Guardar registro y salir',
      confirmExperienceBack: 'Volver',
      applied: 'Lo Apliqué',
      notApplied: 'No lo apliqué',
      backToHome: 'Volver al inicio',
      others: {
        form: {
          tooltipDescription:
            'Queremos conocer otras experiencias que hayas realizado, ejemplo: cuidados a terceras personas, voluntariados, actividades extracurriculares, etc.',
        },
        modal: {
          incomplete: {
            title: 'Recomendación',
            description:
              'Incluye como mínimo entre 10 y 15 de tus habilidades principales para destacarte. De momento quedará incompleto, puedes continuar después.',
          },
          complete: {
            title: 'Finalizar registro de experiencia',
            description:
              'Estás a punto de registrar una nueva experiencia y las habilidades que aprendiste.',
          },
        },
      },
    },
    skills: {
      title: 'Habilidades adquiridas',
      subtitle:
        'Sigue el paso a paso para registrar tu experiencia y habilidades adquiridas.',
      back: 'Atras',
      save: 'Finalizar experiencia',
      goToExperiences: 'Ir a mis experiencias',
      completed: {
        title: '¡Listo! Acabas de registrar una nueva experiencia',
        label:
          '¡Nos gustaría seguir conociéndote! Recuerda que puedes continuar ingresando tus experiencias, estas te ayudarán a robustecer tu inventario de habilidades.',
        goToExperiences: 'Ir a mis experiencias',
        registerNewExperience: 'Registrar nueva experiencia',
      },
      uncompleted: {
        title:
          'No terminaste de ingresar tus habilidades, pero puedes regresar cuando quieras.',
        goToExperiences: 'Ir a mis experiencias',
        back: 'Volver',
      },
    },
  },
  login: {
    title: 'Ingresar',
    form: {
      email: 'Correo electrónico',
      password: 'Contraseña',
      submit: 'Ingresar',
    },
    passwordIncorrect:
      'Error al iniciar sesión, si el problema persiste ponte en contacto con contacto@relink.cl',
    generalError:
      'Oppss! Parece que algo salió mal :( Si el problema persiste, por favor comuníquese con nosotros: contacto@relink.cl',
    forgottenPassword: {
      title: '¿Olvidaste tu contraseña?',
      description:
        '¡No te preocupes! Ingresa tu dirección de correo electrónico en la siguiente casilla. Te enviaremos un enlace que te permitirá crear una nueva contraseña cuando hagas clic en "Solicitar una nueva contraseña".',
      notification:
        'Si formas parte de un piloto Relink y no tienes acceso a un correo electrónico para recuperar tu contraseña, puedes contactarte con tu empleador y/o administrador del piloto para recuperarla.',
      submitButton: 'Solicitar una nueva contraseña',
      backButton: 'Volver',
    },
    confirmation: {
      title1: 'Un momento,',
      title2: 'estamos verificando tu cuenta',
    },
  },
  profile: {
    title: 'Mi Perfil',
    subtitle: 'Desde este módulo podrás modificar tu información.',
    footer:
      'Si tienes alguna pregunta, inquietud o deseas solicitar la eliminación de tu cuenta, puedes comunicarte con nosotros a través del siguiente correo electrónico:',
    region_title: {
      chilean: {
        label: 'Región',
        pholder: '',
      },
      foreign: {
        label: 'Estado/Región/Departamento',
        pholder: 'Escribe o selecciona tu estado/región/departamento',
      },
      company: {
        label: 'País',
        pholder: '',
      },
    },
    identifier_number: {
      chilean: 'RUT',
      foreign: 'Nº de documento de identidad/pasaporte',
      company: 'RUT Empresa',
    },
    addresses: {
      title: {
        home: 'Dirección particular',
      },
      field: {
        home: 'Dirección',
        home_number: 'Depto / Block',
        region: {
          label: 'Región',
          pholder: 'Selecciona una región',
        },
        comune: {
          label: 'Comuna',
          pholder: 'Selecciona una comuna',
        },
        pholder: 'Calle, número, depto/block, lote',
      },
    },
    personalData: {
      title: 'Mis datos personales',
      form: {
        title: 'Editar mis datos personales',
        names: {
          label: 'Nombres',
          pholder: 'Ej. Nombre Nombre',
        },
        policy_data: 'Autorizar tratamiento de datos',
        identifier_number: 'RUT',
        lastnames: {
          label: 'Apellidos',
          pholder: 'Ej. Apellido Apellido',
        },
        gender: {
          label: 'Género',
          pholder: 'Selecciona tu género',
        },
        birthdate: {
          label: 'Fecha de nacimiento',
          pholder: 'Ej. 20/02/1990',
        },
        residentCountry: 'País de residencia',
        phone: {
          label: 'Teléfono',
          pholder: '+56933445566',
        },
        address: 'Dirección',
        originCountry: 'País de origen',
        laboralSituation: 'Situación laboral',
        idNumber: 'RUT',
        company: 'Empresa',
        position: {
          label: 'Cargo',
          pholder: 'Ej. Product Owner',
        },
        language: 'Idioma',
        provide_data: 'Brindar datos de mi perfil',
        educationLevel: 'Nivel educacional',
        edLevel: {
          label: 'Nivel educacional',
          pholder: 'Selecciona tu nivel educacional',
        },
        provide_data_description: {
          start:
            'Al brindar tus datos, aceptas que las instituciones ligadas a Relink que buscan candidatos puedan encontrar información sobre tu perfil y contactarte de acuerdo a ',
          link: 'nuestro términos',
          end: ' establecidos.',
        },
      },
    },
    companyData: {
      title: 'Datos empresa',
      form: {
        name: {
          label: 'Empresa',
          pholder: 'Ej. Company S.A.',
        },
        identification_number: {
          label: 'RUT Empresa',
          pholder: 'Ej. 76.123.456-7',
        },
        country: {
          label: 'País',
          pholder: 'Selecciona tu país',
        },
        createdAt: {
          label: 'Fecha de creación',
          pholder: 'Ej. 20/02/1990',
        },
      },
    },
    employeeData: {
      title: '¡Hola, {name}!',
      subtitle: 'Completa los datos para crear tu perfil',
      form: {
        rut: {
          label: 'RUT:',
          pholder: '11111111-1',
        },
        dateofbirth: {
          label: 'Fecha de nacimiento (dd/mm/aaaa):',
          pholder: 'DD/MM/AAAA',
        },
        gender: {
          label: 'Género:',
          pholder: 'Selecciona tu género',
        },
        edLevel: {
          label: 'Nivel educacional:',
          pholder: 'Selecciona tu nivel educacional',
        },
        region: {
          label: 'Región:',
          pholder: 'Selecciona tu región',
        },
        comune: {
          label: 'Comuna:',
          pholder: 'Selecciona tu comuna',
        },
        terms: {
          start: 'He leído y acepto los',
          link: 'términos y condiciones',
          middle: 'y la',
          link2: 'política de privacidad',
        },
        button: 'Ingresar a mi cuenta',
      },
    },
    accessData: {
      title: 'Mis datos de acceso',
      form: {
        email: 'Correo electrónico',
        password: 'Contraseña',
        changePassword: 'Cambiar contraseña',
        currentPassword: 'Introduce tu contraseña actual',
        newPassword: 'Nueva contraseña (4-16 caracteres)',
        confirmNewPassword: 'Confirmar nueva contraseña',
      },
    },
    messages: {
      passwordChange:
        'Hemos actualizado tu contraseña correctamente. A partir de ahora tendrás que utilizar tu nueva contraseña para acceder al área privada.',
    },
  },
  createPassword: {
    title: 'Crear Contraseña',
    description:
      'Establece tu contraseña para comenzar a utilizar Relink. Si tienes dudas puedes contactar a ',
    company: {
      description:
        'Somos una plataforma que busca apoyar la reconversión laboral de empresas y personas, acompañándolas en su transición hacia las oportunidades de trabajo del futuro. Por último, crea una contraseña para poder iniciar sesión',
    },
    public: {
      description:
        'Ahora podrás ingresar y completar los detalles sobre tu formación y experiencia laboral, lo cual nos permitirá orientarte acerca de las nuevas oportunidades laborales que más se ajustan a tus habilidades. Por último, crea una contraseña para poder iniciar sesión:',
    },
  },
  changePassword: {
    title: 'Restaurar contraseña olvidada',
    description: 'Por favor introduce tu contraseña más abajo.',
    form: {
      password: 'Nueva contraseña:',
      confirmPassword: 'Confirmar nueva contraseña:',
      showPassword: 'Mostrar contraseña',
    },
    placeholder: {
      password: 'Contraseña',
    },
    buttons: {
      save: 'Guardar cambios',
    },
    errors: {
      passwordDontMatch: 'Las contraseñas no coinciden',
    },
  },
  occupations: {
    findOne: {
      description: 'Detalle sobre la ocupación',
    },
    title: {
      list: 'Listado de Ocupaciones',
      search: 'Biblioteca de Ocupaciones',
    },
    description: {
      list: 'Listado de ocupaciones',
      search: 'Biblioteca de Ocupaciones',
    },
    fields: {
      title: 'Ocupaciones',
      skillsRequired: 'Skill Obligatorios',
      hierarchy: 'Jerarquía',
      category: 'Categoría',
    },
    messages: {
      withoutParent: 'Sin categorización',
    },
    form: {
      label: 'Cargo:',
      selectOptions: 'Escribe tú cargo para buscar.',
      recommendations: `<p>No se han encontrado resultados. Selecciona una de las siguientes ocupaciones sugeridas, <span class="recommendation-text">o ingresa tu experiencia a través de <a class="link-other-experiences" href="/experiencias/nuevas/otras?isRedirected=true">Otras experiencias</a></span></p>`,
      noRecommendations: `
      <p>¡Ups! No se han encontrado resultados para tu búsqueda :( </p>
      <p>Sugerencias:</p>
      <ul>
      <li>Asegúrate de que todas las palabras estén escritas correctamente.</li>
      <li>Prueba diferentes palabras clave.</li>
      <li>Prueba palabras clave más generales.</li>
      <li>O ingresa tu experiencia a través de <a class="link-other-experiences" href="/experiencias/nuevas/otras?isRedirected=true">Otras experiencias</a></li>
      </ul>
      `,
    },
    index: {
      empty: 'No hay ocupaciones',
    },
    buttons: {
      newOccupation: 'Nueva ocupación',
    },
  },
  customOccupations: {
    new: {
      title: 'Nueva ocupación personalizada',
      description:
        'Completa el formulario para crear una nueva ocupación personalizada',
      steps: {
        first: {
          label: 'Escoge un perfil base',
          initialState: {
            title: '¿Buscando una ocupación?',
            description:
              'Desde el buscador ingresa al menos 4 caracteres para buscar entre las más de 3.000 ocupaciones disponibles en Relink.',
          },
          table: {
            footer: 'Se están mostrando {0} de {1} resultados',
          },
          placeholder: {
            search: 'Ingresa al menos 4 caracteres...',
            filter: 'Filtrar por',
          },
          skillsOfOccupation: 'Verifique las habilidades del perfil: {0}',
        },
        second: {
          label: 'Ingresa los datos',
          form: {
            title: 'Ingresa los datos de la nueva ocupación',
            name: 'Nombre de la ocupación:',
            description: 'Descripción:',
            dropdown: 'Selecciona una empresa',
            company: 'Empresa:',
            titlePlaceholder: 'Ej: {0}',
          },
        },
        third: {
          label: '¡Listo!',
          title: 'Resumen de la nueva ocupación',
          checkbox: 'No incluir habilidades del perfil base',
          warningStart:
            'No visualizarán ninguna de las habilidades del perfil base en la nueva ocupación.',
          warningEnd: 'No podrás deshacer esta acción más adelante.',
          tooltipText:
            'Verifique que las habilidades que desea trabajar sean las del perfil base. En caso contrario, seleccione "No incluir habilidades del perfil base".',
        },
      },
      modal: {
        add: {
          title: 'Agregar ocupación',
          text: 'Escribe una palabra simple o compuesta:',
          search: 'Ingresa al menos 3 caracteres',
          message:
            'Si estás buscando las siguientes ocupaciones, estas ya se encuentran agregadas:',
          baseOccupationMessage:
            'Si estás buscando {0}, esta es la ocupación base.',
        },
        remove: {
          title: 'Eliminar ocupación',
          boldText: '¿Seguro que deseas eliminar la ocupación?',
          text:
            'Una vez eliminada no podrás visualizar las habilidades asociadas a ella.',
          cancel: 'Cancelar',
          delete: 'Eliminar',
        },
      },
      suggestedSkills: {
        subtitle: {
          first: 'Se sugieren ',
          second: '{0} habilidades ',
          third:
            'esenciales según las ocupaciones previamente mencionadas, ordenadas por frecuencia, ubicando las que más se repiten en la parte superior.',
          fourth:
            'Seleccione las que mejor se adapten a sus intereses y objetivos de la ocupación a personalizar.',
        },
        tooltip: {
          text:
            'Las habilidades visualizadas corresponden a aquellas que cumplen con ser esenciales para las ocupaciones sugeridas, además, están ordenadas según el número de veces que se repiten en las diferentes ocupaciones (de la más repetida a la menos).',
        },
        viewMore: 'Ver {quantitySkillNotVisible} más',
        viewLess: 'Ver menos',
      },
    },
    modal: {
      title: 'Crear una nueva ocupación personalizada',
      description:
        'Para crear una ocupación personalizada, ingresa el nombre de la empresa, luego selecciona un perfil meta base. Podrá editar el nombre de la ocupación y descripción según necesidad.',
      select: {
        company: {
          label: 'Empresa',
          placeholder: 'Selecciona una empresa',
        },
        occupation: {
          label: 'Perfil Meta base',
          placeholder: 'Selecciona un perfil meta base para tu ocupación',
        },
      },
      text: {
        title: {
          label: 'Nombre Ocupación/Cargo',
          placeholder: 'Ejm: Diseñador UX/UI - Nestle',
        },
        description: {
          label: 'Descripción',
          placeholder:
            'Recomendación: Describir las funciones y responsabilidades de este rol, además de considerar el papel de la tecnología en el sector. Evitar la descripción de habilidades blandas, como responsabilidad, puntualidad, etc.',
        },
      },
    },
    title: {
      list: 'Ocupaciones Personalizadas',
    },
    buttons: {
      createOccupation: 'Crear Ocupación',
      cancel: 'Cancelar',
    },
  },
  kanban: {
    pendingAlert: {
      pendingBold:
        'Tienes habilidades que aún necesitas validar su esencialidad.',
      pendingNormal:
        'Hasta que no realices esta acción, no se visualizarán cambios en tu ocupación.',
    },
    buttons: {
      showInsights: 'Estadísticas',
    },
    insightsSection: {
      title: 'ESTADÍSTICAS DE LA OCUPACIÓN',
    },
  },
  myProjects: {
    title: 'Mis proyectos',
    breadcrumb: 'Mis proyectos',
    description:
      'Cree, gestione y realice todo el seguimiento de sus proyectos de selección desde este módulo.',
    table: {
      filters: {
        text: {
          placeholder: 'Buscar proyecto',
        },
        status: {
          placeholder: 'Estado de proyecto',
          options: {
            active: 'En curso',
            close: 'Finalizado',
          },
        },
      },
      columns: {
        name: 'Nombre del proyecto',
        status: 'Estado',
        services: 'Servicios',
        registerDate: 'Fecha de creación',
        closedDate: 'Fecha de término',
        type: 'Tipo',
      },
      services: {
        matchPotential: 'Potencial de Match',
        skillsInventory: 'Inventario de Habilidades',
      },
      empty: 'No hay datos para mostrar',
    },
  },
  projects: {
    title: 'Nuevo proyecto',
    breadcrumb: 'Nuevo proyecto',
    description: {
      text:
        'Puedes crear un nuevo proyecto a través de los siguientes pasos: ingresa tu información, selecciona los servicios que consideres necesarios y añade a los usuarios que participarán en el proyecto. Una vez validada la información, crea tu proyecto y los usuarios serán notificados automáticamente.',
    },
    new: {
      steps: {
        configuration: {
          label: 'Configuración',
          sections: {
            objective: {
              title: '¿Cuál es el objetivo del proyecto?',
              description:
                'Elige el tipo que mejor se adapte a tu proyecto. Con esa información podemos brindarte una asesoría más personalizada.',
            },
            type: {
              title: 'Mide las habilidades de tus colaboradores para:',
              description:
                'Mediante este proceso, se definirán las habilidades a preguntar para obtener un diagnóstico más certero.',
              reskilling: 'Reinvención laboral ',
              detail_reskilling:
                'Identifica las habilidades necesarias para desarrollar nuevas trayectorias laborales',
              tooltip_reskilling:
                'Conocido también como Reskilling o proceso de cambio de ocupación, rol o área',
              upskilling: 'Actualización de habilidades',
              detail_upskilling:
                'Identifica las oportunidades de formación y actualización del perfil laboral de tus colaboradores',
              tooltip_upskilling:
                'Conocido también como Upskilling o proceso de actualización del perfil laboral mediante la adquisición, mejora o desarrollo de habilidades',
              selfdiagnosis: 'Conocer brechas actuales',
              detail_selfdiagnosis:
                'Identifica el estado de las habilidades de tus colaboradores respecto de sus actuales perfiles laborales',
              models: 'Empleabilidad y productividad',
              detail_models:
                'Conoce la brecha de tus colaboradores respecto a nuestros kit de habilidades de empleabilidad y productividad',
              tooltip_models:
                'Conjunto de habilidades específicas para gestionar empleabilidad y productividad',
            },
            profile: {
              title: '¿Qué perfil te gustaría diagnosticar para este proyecto?',
              title2: '¿A qué perfil te gustaría dirigirlos?',
              subtitle:
                'Escribe al menos 4 caracteres y aguarda para ver los resultados...',
              placeholder: 'Ej. Jefe de logística',
            },
            origin: {
              title:
                '¿Qué roles o perfiles ocupan actualmente las personas que participarán en el proyecto? (opcional)',
              description:
                'En caso, de no tenerlos claros, puedes simplemente hacer clic en el botón “Guardar y continuar”.',
              addButton: 'Perfil',
              modalAddOrigin: {
                title: 'Añadir Perfiles',
                instructions: 'Ingresa los perfiles que consideres necesarios:',
                placeholder:
                  'Escribe al menos 4 caracteres y aguarda para ver los resultados...',
              },
            },
          },
        },
        models: {
          only_models: {
            title:
              'Selecciona uno o varios Kits de Habilidades necesarios para tu proyecto',
            subtitle:
              'Explora nuestros Kits de habilidades base. Puedes escoger entre los kits para la Empleabilidad y para la Productividad. Selecciona el o los que mejor se ajusten a las necesidades de tu proyecto.',
          },
          with_models: {
            title:
              '¿Quieres complementar tus proyectos de identificación de habilidades?',
            subtitle:
              'Si estás realizando un proceso de Reinvención laboral, Actualización laboral o Reporte de habilidades, puedes complementarlo con nuestros Kits de habilidades base. Puedes escoger entre los kits para la Empleabilidad y para la Productividad. Selecciona el o los que mejor se ajusten a las necesidades de tu proyecto.',
          },
        },
        supervisorAssignment: {
          infoMessage: {
            normalMessage:
              'Puedes elegir varios usuarios y asignarles un mismo supervisor.',
            strongMessage:
              'Asegúrate de que cada colaborador cuente con uno asignado.',
          },
          title: 'Designa supervisores a los colaboradores',
          subtitle:
            'Revisa la lista de colaboradores y asigna un supervisor responsable acada uno.',
          selectedUsers: 'Usuarios seleccionados:',
          assignButton: 'Asignar supervisor',
        },
        first: {
          label: 'Introducción datos',
          title: '¿Qué tipo de proyecto desea trabajar?',
          objectiveInfo: 'Más información sobre objetivos',
          seeMore: 'ver más',
          modal: {
            objectives: {
              title: 'Objetivos de proyecto',
              list: {
                intern: {
                  title: 'Movilidad interna: ',
                  description:
                    'Encontrar a los colaboradores que poseen las habilidades claves para su movimiento dentro de la organización.',
                },
                talent: {
                  title: 'Atracción de talento: ',
                  description:
                    'Descubrir a los candidatos y candidatas ideales que coincidan con el perfil que busco desde fuera de la organización.',
                },
                unbundling: {
                  title: 'Generación de rutas formativas: ',
                  description:
                    'Diseñar rutas de capacitación para potenciar a colaboradores.',
                },
                others: {
                  title: 'Personalizado: ',
                  description:
                    'Si las opciones anteriores no se ajustan a tu proyecto, puedes crear tu propio objetivo.',
                },
              },
            },
          },
          form: {
            name: {
              label: 'Nombre del proyecto:',
              placeholder: 'Ej: Reconversión TI 2023',
            },
            type: {
              label: 'Tipo del proyecto:',
            },
            objective: {
              label: 'Objetivo:',
              placeholder: 'Selecciona un objetivo de proyecto',
            },
            objectiveDetail: {
              label: 'detalle de objetivo',
              placeholder: 'Ej: Mejorar los procesos de la productividad',
            },
            targetOccupation: {
              label: 'Perfil de futuro:',
              alternativeLabel: 'Perfil a diagnosticar:',
            },
            skillsModels: {
              label: 'Empleabilidad y productividad:',
            },
            description: {
              label: 'Descripción:',
              pholders: {
                intern:
                  'Encontrar a los colaboradores que poseen las habilidades claves para su movimiento dentro de la organización.',
                talent:
                  'Descubrir a los candidatos y candidatas ideales que coincidan con el perfil que busco desde fuera de la organización.',
                unbundling:
                  'Diseñar rutas de capacitación para potenciar a colaboradores.',
                others:
                  'Nos gustaría saber qué esperas lograr, qué metas te has propuesto o qué deseas alcanzar con este proyecto.',
              },
            },
            locations: {
              label: 'Localización:',
              placeholder: 'Selecciona una o más regiones',
            },
            modality: {
              label: 'Modalidad del proyecto:',
              placeholder: 'Selecciona una modalidad del proyeto',
            },
          },
          objectives: {
            intern: 'Movilidad interna',
            talent: 'Atracción de talento',
            unbundling: 'Generación de rutas formativas',
            others: 'Personalizado',
          },
          modalities: {
            presential: 'Presencial',
            remote: 'Remoto',
            hybrid: 'Híbrido (Presencial/Remoto)',
          },
          types: {
            reskilling: 'Reinvención laboral',
            upskilling: 'Actualización de habilidades',
            selfdiagnosis: 'Conocer brechas actuales',
            models: 'Empleabilidad y productividad',
          },
        },
        second: {
          label: 'Selección de servicios',
          title: '¿Qué tipo de servicio desea añadir?',
          subtitle:
            'Selecciona el servicio que consideras necesario para tu proyecto. Puedes elegir uno o escoger ambos.',
          match: {
            title: 'Potencial de match',
            description:
              'Te mostraremos cuáles son las ocupaciones que se ajustan mejor al perfil de tus colaboradores.',
          },
          inventory: {
            title: 'Inventario de habilidades',
            description:
              'Podrás disponer de data estadística sobre las habilidades registradas por tu organización.',
          },
          buttons: {
            add: 'Añadir',
            added: '¡Añadido!',
          },
          occupations: {
            title: 'Selecciona las ocupaciones que necesitas para tu proyecto',
            description:
              'Seleccionaste el servicio de Potencial de match para tu proyecto, ahora deberás escoger las ocupaciones que deseas contrastar con tus colaboradores. Puedes elegir una o las que consideres necesarias.',
            placeholder: 'Selecciona un cargo u ocupación',
          },
        },
        third: {
          label: 'Añadir usuarios',
          alertMessage:
            'Los usuarios solo serán invitados y notificados una vez finalizado el proceso de creación y validación del proyecto.',
          addUsers: 'Añadir usuarios',
          invitationMessage: 'Ajustes de invitaciones',
          search: 'Buscar...',
          customMessage: {
            title: 'Ajustes de invitaciones',
            subtitle: 'Agregar mensaje personalizado (opcional):',
            placeholder:
              '¿Qúe mensaje personal, le gustaría añadir al contenido de su correo de invitación?',
            preview: 'Previsualizar invitación',
            cancel: 'Cancelar',
            save: 'Guardar',
          },
        },
        fourth: {
          label: 'Validación de la información',
          title: 'Validación de la información',
          subtitleOne:
            '¡Ya estamos casi! Revisa en detalle la información que ingresaste.',
          subtitleTwo:
            ' Si consideras que está correcta puedes hacer clic en "Validar y crear proyecto". Luego de esto los usuarios serán notificados.',
          form: {
            occupations: {
              label: 'Ocupaciones potencial de match:',
            },
            customInvitation: {
              label: 'Mensaje personalizado invitación:',
            },
            type: {
              label: 'Tipo de proyecto:',
            },
            target: {
              selfdiagnosis: 'Perfil a diagnosticar:',
              others: 'Perfil a dirigir:',
            },
            originEntities: {
              label: 'Perfiles participantes:',
            },
          },
        },
        fifth: {
          label: 'Proyecto creado',
          title: '¡El proyecto “{0}” ha sido creado!',
          subtitleOne:
            'Tu nuevo proyecto ya se encuentra creado en la plataforma y los usuarios ya han sido notificados a través del email.',
          subtitleTwo:
            '¡Recuerda que en caso de tener usuarios que no cuenten con un email, es importante que entregues su información! Para más detalles puedes dirigirte a la sección "Usuarios" del proyecto.',
          button: 'Ir a mi proyecto',
          success:
            '¡Felicidades! Ha creado correctamente un nuevo proyecto en Relink.',
        },
      },
    },
    projectDetailTab: {
      searchUser: 'Buscar usuario...',
      withEmail: 'Con email',
      withoutEmail: 'Sin email',
      typeOfUser: 'Tipo de usuario: ',
      incomplete: 'Incompleto',
      complete: 'Completo',
      progress: 'Estado de avance: ',
      quizModelQuestionary: 'Avance de cuestionario de kit de habilidades: ',
      quizCurrentQuestionary:
        'Avance de cuestionario de identificación de habilidades: ',
      pending: 'Pendiente',
      accepted: 'Aceptada',
      invitationStatus: 'Estado de invitación: ',
      close: 'Cerrar',
      inviteUsers: 'Invitar usuarios',
      resendInvitation: 'Reenviar invitación',
      announcement:
        'Para los usuarios que no posean correo electrónico, su contraseña sera: <b>relink123</b>',
      configureEmails: 'Ajustes de invitaciones',
      invitationList: {
        selectedUsers: 'Usuarios seleccionados',
        name: 'Nombre',
        username: 'Nombre de usuario',
        userEmail: 'Correo electrónico de usuario',
        email: 'Email',
        tooltipCustom: {
          title: 'Simbología:',
          desc1: 'Usuario con email',
          desc2: 'Usuario sin email',
        },
        quizModelQuestionary: 'Empleabilidad y productividad',
        quizCurrentQuestionary: 'Identificación de habilidades',
        invitationStatus: 'Estado de invitación',
        invitationDate: 'Fecha de invitación',
        actions: 'ACCIONES',
        userProfile: 'Ver perfil de usuario',
        resendInvitation: 'Reenviar invitación',
        removeUser: 'Retirar del proyecto',
        tooltipButton: 'Enviar recordatorio',
        tooltipCurrentTitle:
          'Proyectos de identificación de habilidades: Reinvención laboral, Actualización de habilidades y Reporte de habilidades.',
        tooltipModelTitle:
          'Proyectos de kit de habilidades de Empleabilidad y kit de habilidades de Productividad',
      },
    },
    modalResendMassive: {
      title: 'Reenviar invitación masiva',
      description: 'Mensaje personalizado (Opcional)',
      placeholder:
        '¿Qúe mensaje como recordatorio, le gustaría añadir al contenido de su correo de invitación?',
      prevInvi: 'Previsualizar invitación',
      cancel: 'Cancelar',
    },
    projectUserList: {
      email: 'Email',
      name: 'Nombre',
      invitation_date: 'Fecha de invitación',
      actions: 'Acciones',
    },
    projectSupervisorCollaboratorList: {
      email: 'Email',
      name: 'Nombre',
      typeUser: 'Tipo de usuario',
      actions: 'Acciones',
    },
    modalDeleteUser: {
      title: 'Retirar del proyecto',
      description1: '¿Seguro que deseas retirar a',
      description2: 'del proyecto?',
      cancel: 'Cancelar',
      delete: 'Sí',
    },
    modalErrorUsers: {
      error: 'No se pudo realizar la acción:',
      back: 'Volver',
    },
    modalEditUsers: {
      names: 'Nombres',
      names_placeholder: 'Ej: Nombre Nombre',
      email: 'Email',
      placeholder_email: 'Ej: usuario@gmail.com',
      rut: 'RUT',
      placeholder_rut: 'Ej: 15677899-1',
      surname: 'Apellidos',
      placeholder_surname: 'Ej: Apellido Apellido',
      repeat_email: 'Repetir Email',
      cancel: 'Cancelar',
      save: 'Guardar',
    },
    addUsers: {
      names: 'Nombres*',
      names_placeholder: 'Ej: Nombre Nombre',
      email: 'Email',
      placeholder_email: 'Ej: usuario@gmail.com',
      rut: 'RUT*',
      placeholder_rut: 'Ej: 15677899-1',
      surname: 'Apellidos*',
      placeholder_surname: 'Ej: Apellido Apellido',
      repeat_email: 'Repetir Email',
      mandatory: '(*) campos obligatorios',
    },
    modalAddUsers: {
      title: 'Agregar usuarios',
      button: 'Añadir',
      tabs: {
        search: {
          title: 'Buscar',
          multiselect: {
            placeholder: 'Buscar Usuarios ...',
            option: {
              tagInProject: 'Pertenece al proyecto',
              tagInOtherProject: 'Pertenece a otro proyecto',
            },
            noOptions:
              '¡Ups!, no hemos encontrado resultados para tu búsqueda. Verifica que todas las palabras estén escritas correctamente.',
          },
          instructions: {
            title: 'Sugerencias:',
            description:
              'Los siguientes 10 usuarios se encuentran actualmente sin un proyecto asociado.',
          },
          suggestedUserList: {
            selectAll: 'Seleccionar Todos',
          },
        },
        add: {
          title: 'Añadir',
        },
      },
    },
    modalSupervisorCollaborator: {
      title: 'Añadir usuarios',
      description: 'Elige el tipo de usuario que deseas elegir',
      collaboratorCard: {
        title: 'Colaborador',
        description:
          'Completa un cuestionario para realizar un autoreconocimiento de sus habilidades.',
      },
      supervisorCard: {
        title: 'Supervisor',
        description:
          'Evalúa las habilidades de los colaboradores a tu cargo, según tu propio criterio.',
      },
      button: 'Salir',
    },
    detail: {
      badges: {
        createdAt: 'Fecha de creación',
        endAt: 'Fecha de finalización',
        modality: 'Modalidad',
        users: 'Usuarios',
        reports: 'Reporteria de proyecto',
      },
      tabs: {
        information: 'Detalle del Proyecto',
        users: 'Usuarios',
        supervisors: 'Supervisores',
        collaborators: 'Colaboradores',
        supervisorsValidations: 'Validaciones de supervisores',
        invitations: 'Ajustes de invitaciones',
        quiz: 'Avance de cuestionarios',
        inventorySkills: 'Inventario de habilidades',
        matchPotential: 'Potencial de match',
        models: 'Empleabilidad y productividad',
      },
      matchPotential: {
        chartByAge: {
          title: 'Rango de edad',
          tooltip:
            'Promedio total de match por edad registrado en este proyecto',
          errorMessage:
            'Ocurrió un error al cargar los datos de match por edad',
        },
        chartByGender: {
          title: 'Género declarado',
          tooltip:
            'Promedio total de match registrado por género en este proyecto',
          errorMessage:
            'Ocurrió un error al cargar los datos de match por género',
        },
        chartMatchDistribution: {
          title: 'Distribución de porcentaje de match con perfil meta',
          subtitle:
            ' Visualiza la distribución y proximidad de cada colaborador respecto al perfil meta del proyecto, considerando sus porcentajes de match y cantidad de habilidades ingresadas en el proceso.',
          tooltip:
            'Ubicación de los colaboradores considerando porcentajes de match de la ocupación y la cantidad de habilidades ingresadas.',
        },
        percentageMatch: 'Porcentaje de match',
        gapSkills: 'Brecha de habilidades',
        empty: 'No hay datos para mostrar',
        filters: {
          text: {
            placeholder: 'Buscar usuario...',
          },
          match: {
            label: 'Filtrar por rango:',
          },
        },
        breadcrumb: 'Potencial de match',
        title: 'Potencial de match',
        description:
          'Explora el porcentaje de coincidencia entre las habilidades reconocidas en las personas de tu organización y las requeridas por tu perfil meta. Esto te permitirá identificar fortalezas y brechas.',
        table: {
          gapSkills: 'Cuenta con {0} de {1} habilidades requeridas',
          footer: '{0} de {1}',
        },
        maxMatch: {
          title: 'Mayor Match',
          errorMessage: 'Ocurrió un error al cargar los datos de match',
          label:
            'Usuario con mayor coincidencia entre habilidades ingresadas y el perfil meta',
        },
        matchAverage: {
          title: 'Promedio de match',
          errorMessage: 'Ocurrió un error al cargar los datos de match',
          label:
            'Coincidencia entre las habilidades ingresadas y el perfil contrastado',
          subtitleLabel: 'Del Proyecto',
        },
      },
      reports: {
        executive: 'Reporte Ejecutivo',
        inventory: 'Inventario',
        match: 'Match + Cursos',
        experiences: 'Experiencias',
        skills: 'Habilidades a trabajar',
        models: 'Empleabilidad y productividad',
        pdf: 'Exportar Reporte',
        validationSkills: 'Validación de supervisores',
      },
      buttons: {
        delete: 'Eliminar proyecto',
        finish: 'Finalizar proyecto',
        saveChanges: 'Guardar cambios',
      },
      summary: {
        projectResults: 'Resultados del proyecto',
        inventory: 'Ver inventario de habilidades',
        match: 'Potencial de match:',
        otherMatches: 'Otros potenciales de match',
        modelResults: 'Resultados de los modelos',
        showModelResults: 'Ver resultados',
        name: 'Nombre:',
        type: 'Tipo de proyecto:',
        targetOccupation: 'Perfil de futuro:',
        targetOccupationAlternative: 'Perfil a diagnosticar:',
        includedModelsLabel: 'Empleabilidad y productividad:',
        objective: 'Objetivo:',
        description: 'Descripción:',
        locations: 'Localización:',
        status: 'Estado:',
      },
      modals: {
        update: {
          title: 'Editar proyecto',
        },
        delete: {
          title: '¡Atención!',
          subtitle: '¿Realmente quieres eliminar tu proyecto?',
          descriptionOne: 'Esta operación no se puede deshacer.',
          descriptionTwo:
            'Ten en cuenta que si continúas perderás definitivamente toda la información y, ya no estará disponible para los usuarios participantes del mismo.',
          button: 'Eliminar proyecto',
        },
        finish: {
          title: '¡Atención!',
          subtitle: '¿Realmente quieres finalizar tu proyecto?',
          descriptionOne:
            'Ten en cuenta que si continúas, los usuarios participantes del mismo no podrán ver su match actual y quedarán liberados para futuros proyectos.',
          descriptionTwo:
            '¡Recuerda que no podrás volver a activar el proyecto, pero sí podrás visualizar los datos!',
          button: 'Finalizar proyecto',
        },
      },
      models: {
        title: 'Ranking de match con empleabilidad y productividad',
        description:
          'Visualiza los porcentajes de match de tus colaboradores con los Kit de habilidades para la empleabilidad y la productividad. El color de cada casilla identifica el grado de coincidencia de habilidades con un kit en específico.',
        label:
          'Visualización de las brechas de los colaboradores respecto al Kit de habilidades',
      },
      supervisors: {
        search: 'Buscar...',
        invitationStatus: 'Estado de invitación',
        addSupervisor: 'Añadir Supervisor',
        selectedUsers: 'Usuarios seleccionados:',
        resendInvitation: 'Reenviar Invitación',
        table: {
          supervisors: 'Supervisores',
          invitationStatus: 'Estado de invitación',
          validationProcessProgress: 'Avance proceso de validación',
          actions: 'Acciones',
          tooltips: {
            invitationStatus:
              'El usuario ingresa por primera vez a la plataforma.',
            validationProcessProgress:
              'Avance de colaboradores validados por el supervisor.',
          },
          actionItems: {
            validationReminder: 'Enviar recordatorio de validación',
            resendInvitation: 'Reenviar invitación',
            viewCollaborators: 'Ver colaboradores  asignados',
            removeFromProject: 'Retirar del proyecto',
          },
        },
        assignedCollaboratorsModal: {
          title: 'Colaboradores asignados',
          search: 'Buscar colaborador...',
          seeMore: 'Ver más',
          noAssignedCollaborators:
            'No se han asignado colaboradores para su validación.',
          addCollaborators: 'Añadir colaboradores',
        },
        resendMassiveInvitationModal: {
          title: 'Reenviar invitación masiva',
          subTitle: '¡Yey! ¡Todos invitados!',
          text:
            'Se acaban de enviar las invitaciones, puedes revisar el estado de estas desde el módulo de tu proyecto.',
          backButton: 'Volver',
        },
        removeSupervisorModal: {
          title: 'Retirar del proyecto',
          text:
            '¿Seguro que deseas retirar a <strong>{name}</strong> del proyecto?',
          cancelButton: 'Cancelar',
          confirmButton: 'Sí',
        },
        assignSupervisorModal: {
          title: 'Asigna un nuevo supervisor a los colaboradores',
          collaboratorColumnLabel: 'Nombre',
          supervisorColumnLabel: 'Supervisor asignado',
          selectPlaceholder: 'Selecciona un supervisor/a...',
          assignLaterButton: 'Cancelar',
          confirmButton: 'Confirmar',
        },
        removeSupervisorWithCollaboratorsModal: {
          title: 'Retirar del proyecto',
          subtitle: '¡El supervisor cuenta con colaboradores asignados!',
          text:
            '¿Confirma esta acción? Una vez ejecutada, no podrá deshacerse y será necesario asignar nuevamente un supervisor a los colaboradores previamente asignados a <strong>{name}</strong>.',
          cancelButton: 'Volver',
          confirmButton: 'Confirmar',
        },
        notifications: {
          addSupervisor: 'El supervisor se añadió al proyecto correctamente.',
          removeSupervisor: 'Se ha retirado al supervisor del proyecto.',
        },
        massiveImport: {
          supervisorAlreadyImportedError:
            'el usuario ya es supervisor en este proyecto.',
        },
      },
    },
    types: {
      reskilling: 'Reinvención laboral',
      upskilling: 'Actualización de habilidades',
      selfdiagnosis: 'Conocer brechas actuales',
      models: 'Empleabilidad y productividad',
    },
    modalAddOccupation: {
      title: 'Crear ocupación',
      description:
        'Para incorporar una nueva ocupación, selecciona del listado aquella que más se ajuste a sus necesidades. Una vez que hayas seleccionado la ocupación, indica el nombre del proyecto al cual será asociado.',
      textAction: 'Crear ocupación',
    },
  },
  questionaryProject: {
    modals: {
      start: {
        modalTitle: 'Inicio del Cuestionario',
        title: '¿Estás preparado/a para comenzar?',
        description: {
          first:
            'Te invitamos a responder las siguientes preguntas sobre tus habilidades a lo largo de tu ',
          main: 'experiencia.',
          second: '',
        },
        actions: {
          acceptButton: 'Entendido',
        },
      },
      nextStep: {
        modalTitle: 'Siguiente etapa',
        title: '¡Ya casi hemos terminado!',
        description: {
          first: 'Ahora, comparte con nosotros más',
          main:
            ' habilidades que has adquirido en tu vida laboral o académica ',
          second:
            'y que podrían ser útiles para el futuro del mercado laboral.',
        },
        actions: {
          acceptButton: 'Entendido',
        },
      },
    },
    validateSkills: {
      wizard: {
        step1: 'Experiencia Actual',
        step2: 'Reconoce tus habilidades',
        step3: ' ¡Listo!',
      },
      subsections: {
        skills: {
          isStart: {
            title:
              '¿Has realizado alguna de estas <strong>actividades</strong> en tu cargo actual?',
            titleCollege:
              '¿Has realizado alguna de estas <strong>actividades</strong>?',
            description:
              '<strong>Marca tantas opciones como desees.</strong> Si no cuentas con alguna, no te preocupes,  solo haz clic en "Continuar":',
          },
          isNotStart: {
            title:
              '<strong>Sigamos adelante</strong/>, continúa eligiendo las <strong>actividades</strong> que has realizado...',
            description:
              '<strong>Marca tantas opciones como desees.</strong> Si no cuentas con alguna, no te preocupes,  solo haz clic en "Continuar":',
          },
        },
        knowledges: {
          isStart: {
            title:
              '<strong>Ahora cuéntanos</strong> ¿Tienes <strong>conocimiento</strong> sobre alguno de estos temas?',
            titleCollege:
              '<strong>Ahora cuéntanos</strong> ¿Tienes <strong>conocimiento</strong> sobre alguno de estos temas?',
            description:
              '<strong>Marca tantas opciones como desees.</strong> Si no cuentas con alguna, no te preocupes,  solo haz clic en "Continuar":',
          },
          isNotStart: {
            title:
              '<strong>Avancemos,</strong> continúa seleccionando los <strong>conocimientos<strong/> que posees...',
            description:
              '<strong>Marca tantas opciones como desees.</strong> Si no cuentas con alguna, no te preocupes,  solo haz clic en "Continuar":',
          },
        },
        reuseCommons: {
          isStart: {
            title:
              'Selecciona las <strong>habilidades</strong> que crees tener o has puesto en práctica...',
            titleCollege:
              'Selecciona las <strong>habilidades</strong> que crees tener o has puesto en práctica...',
            description:
              '<strong>Marca tantas opciones como desees.</strong> Si no cuentas con alguna, no te preocupes,  solo haz clic en "Continuar":',
          },
          isNotStart: {
            title:
              '<strong>Continúa</strong> marcando las <strong>habilidades</strong> que crees tener o has puesto en práctica...',
            description:
              '<strong>Marca tantas opciones como desees.</strong> Si no cuentas con alguna, no te preocupes,  solo haz clic en "Continuar":',
          },
        },
        reuseSpecifics: {
          isStart: {
            title:
              'Selecciona las <strong>habilidades</strong> que crees tener o has puesto en práctica...',
            titleCollege:
              'Selecciona las <strong>habilidades</strong> que crees tener o has puesto en práctica...',
            description:
              '<strong>Marca tantas opciones como desees.</strong> Si no cuentas con alguna, no te preocupes,  solo haz clic en "Continuar":',
          },
          isNotStart: {
            title:
              '<strong>Continúa</strong> marcando las <strong>habilidades</strong> que crees tener o has puesto en práctica...',
            description:
              '<strong>Marca tantas opciones como desees.</strong> Si no cuentas con alguna, no te preocupes,  solo haz clic en "Continuar":',
          },
        },
      },
      close: {
        title: '¡Felicitaciones! Ya contestaste todas las preguntas',
        description:
          '¡Ya puedes revisar los resultados de tu cuestionario! Si deseas obtener un diagnóstico más preciso para seguir avanzando en tu crecimiento profesional, no dudes en continuar compartiendo tus experiencias.',
        cards: {
          results: {
            title: 'Revisa el resultado de tu cuestionario',
            action: 'Ver mis resultados',
          },
          inventory: {
            title: 'Revisa tu inventario de habilidades',
            action: 'Ver mi inventario',
          },
          experiences: {
            title: 'Cuéntanos más sobre ti',
            action: 'Ingresar experiencias',
          },
        },
      },
      emptyState: {
        main:
          '¡Hey! En esta sección, ya has identificado las habilidades necesarias en un cuestionario anterior.',
        modelVariant:
          '¡Hey! En esta sección, ya has identificado las habilidades necesarias.',
        text:
          'Ahora puedes avanzar a la siguiente etapa haciendo clic en el botón "Continuar".',
      },
    },
  },
  questionaryModels: {
    validateSkills: {
      inProgress:
        '<strong>Sigamos adelante</strong>, continúa eligiendo las <strong>habilidades y/o conocimientos</strong> que has realizado en tu experiencia o formación...',
      start:
        '<strong>Comencemos</strong>, ¿Has aplicado estas <strong>habilidades y/o conocimientos</strong> en tu experiencia o formación?',
      finish:
        '<strong>Y por último,</strong> selecciona las <strong>habilidades y/o conocimientos</strong> que posees...',
      description:
        '<strong>Marca tantas opciones como desees.</strong> Si no cuentas con alguna, no te preocupes,  solo haz clic en "Continuar":',
    },
  },
  skillsInventory: {
    history: {
      start: 'Inicio',
      myServices: 'Mis servicios',
    },
    title: {
      breadcrumb: 'Inventario de Habilidades',
      list: 'Conoce el Inventario de habilidades de tu organización',
    },
    description: {
      text:
        'Revisa la distribución de habilidades en tu empresa según género y rango etereo, además de las habilidades registradas por los integrantes de tu organización.',
    },
    skillStats: {
      byAge: {
        title: 'Habilidades por rango de edad',
        description:
          'Total de habilidades registradas por edad en todos los proyectos',
      },
      byGender: {
        title: 'Habilidades por género',
        description:
          'Total de habilidades registradas por género en todos los proyectos',
      },
    },
    reminder: {
      text:
        'Recuerda invitar a tus colaboradores a seguir ingresando sus experiencias.',
    },
    error: {
      download: 'Ocurrió un error al descargar el archivo',
      skillDetail: 'Ocurrió un error al obtener el detalle de la habilidad',
      skillStats: 'Ocurrió un error al obtener las estadísticas de habilidades',
    },
    buttons: {
      downloadReport: {
        desktop: 'Descargar reporte',
        mobile: 'Descargar',
      },
      sendReminder: {
        text: 'Enviar comunicado',
      },

      download: {
        label: 'Descargar',
        options: {
          inventorySkills: {
            label: 'Inventario de habilidades',
            description: 'Empresa',
            fileName: 'Inventario-{0}-{1}.xlsx',
          },
          exportReport: {
            label: 'Exportar reporte',
            fileName: 'Inventario-{0}-{1}.pdf',
          },
        },
      },
      search: 'Buscar',
    },
    modalMassReminder: {
      description:
        'Al enviar un recordatorio masivo podrás invitar a todos tus colaboradores a que ingresen sus experiencias en la plataforma y puedan crear su Inventario de Habilidades.',
      project: 'Proyecto:',
      placeholder_project: 'Selecciona un proyecto',
      personalizeMess: 'Agregar mensaje personalizado (Opcional):',
      prevInvi: 'Previsualizar invitación',
      cancel: 'Cancelar',
    },
    modalSuccess: {
      title: 'Tus colaboradores han sido informados',
      description:
        'Puedes enviar esta invitación masiva todas las veces que estimes conveniente.',
      button: 'Cerrar',
    },
    companySkills: {
      title: 'Búsqueda de habilidades ingresadas',
      description:
        'Explora las habilidades registradas por los usuarios de tu empresa en todos proyectos asociados. Puedes buscar habilidades específicas y ver qué colaboradores las poseen.',
      filters: 'Filtros:',
      searchSkill: 'Buscar Habilidad...',
      skillType: 'Clasificación: ',
      reuseLevel: 'Nivel de Reusabilidad: ',
      position: 'Cargo: ',
      filterButton: 'Mostrar opciones de búsqueda',
      allCategories: 'Todas las categorías',
    },
    table: {
      columns: {
        skills: 'Habilidad',
        skillType: 'Clasificación',
        reuseLevel: 'Nivel de Reusabilidad',
        totalUsers: 'Nº Usuarios',
        totalPositions: 'Cantidad Cargos',
        viewDetail: 'Ver Detalle',
      },
      footer: '{0} de {1} resultados',
      noData: 'No hay datos para mostrar',
      tooltips: {
        skillType:
          'Las habilidades pueden clasificarse en cuatro tipos: conocimientos; habilidades; competencias lingüísticas y competencias transversales.',
        reuseLevel:
          'La reusabilidad de una habilidad indica cuán aplicable es dentro de una o más ocupaciones y sectores, por lo cual hallará cuatro niveles: transversal; intersectorial; específica de un sector; especifica de una ocupación.',
      },
    },
    charts: {
      ByType: {
        title: 'Tipo de clasificación',
        tooltipTitle: 'Total habilidades:',
        description: {
          employee:
            'Revisa la distribución de todas tus habilidades, conocimientos y competencias, las cuales son clasificadas en:',
          company:
            'Revisa la distribución de todas las habilidades, conocimientos y competencias registradas por su organización, las cuales son clasificadas en:',
        },
        info: {
          knowledge: {
            name: 'Conocimientos',
            description:
              ': refiere al conjunto de hechos, principios, teorías y prácticas que se relacionan con un campo de trabajo o estudio.',
          },
          linguisticCompetence: {
            name: 'Competencias lingüísticas',
            descriptionTitle:
              'Competencias lingüísticas y conocimiento de lenguas',
            description:
              ': son las competencias referentes a la habilidad de comunicar a través de la escritura, lectura, habla y escucha en un lenguaje específico.',
          },
          skills: {
            name: 'Habilidades',
            description:
              ': es la capacidad de aplicar conocimientos y destrezas personales en entornos de trabajo.',
          },
          transversalCompetence: {
            name: 'Competencias transversales',
            description:
              ' (actitudes y valores): abarcan aquellas competencias fundamentales para la mayoría de ocupaciones y sectores, pues hacen parte de los componentes básicos para el desarrollo de las habilidades y competencias "duras" necesarias para tener éxito en el mercado laboral.',
          },
        },
      },
      ByReuseLevel: {
        title: 'Tipo de reusabilidad',
        tooltipTitle: 'Total habilidades:',
        description: {
          employee:
            'Verifica la distribución del total de tus habilidades registradas según su reusabilidad, lo que indica cuán aplicable es una habilidad por su generalidad o especificidad dentro de una o más ocupaciones y sectores. Encontrarás cuatro niveles:',
          company:
            'Verifica la distribución del total de habilidades registradas por su organización según su reusabilidad, lo que indica cuán aplicable es una habilidad por su generalidad o especificidad dentro de una o más ocupaciones y sectores. Encontrará cuatro niveles:',
        },
        info: {
          transversal: {
            name: 'Transversal',
            descriptionTitle: 'Nivel transversal',
            description:
              ': son relevantes para una gama amplia de ocupaciones y sectores.',
          },
          intersectorial: {
            name: 'Intersectorial',
            descriptionTitle: 'Nivel intersectorial',
            description:
              ': son relevantes para diversas ocupaciones en varios sectores económicos.',
          },
          sectorSpecific: {
            name: 'Específicas del sector',
            descriptionTitle: 'Nivel específico del sector',
            description:
              ': son relevantes para más de una ocupación dentro de un sector.',
          },
          occupationSpecific: {
            name: 'Específicas de la ocupación',
            descriptionTitle: 'Nivel específico de una ocupación',
            description:
              ': generalmente se aplican solo dentro de una ocupación y sus especialidades.',
          },
        },
      },
    },
    skillDetail: {
      labelSearch: 'Trabajadores que cuentan con la habilidad ({0}):',
      searchWorker: 'Buscar trabajador...',
      table: {
        user: 'Usuario',
        position: 'Cargo',
        detail: 'Detalle',
      },
    },
  },
  mySkillsInventory: {
    title: {
      breadcrumb: 'Mi Inventario de Habilidades',
      list: 'Mi Inventario de Habilidades',
    },
    description: {
      text:
        'Con el Inventario de habilidades dispondrás de data estadística sobre tus experiencias registradas. A través de gráficos, indicadores y tablas, obtendrás una mirada más precisa de cuál es el estado actual de tus habilidades, conocimientos y competencias.',
    },
    buttons: {
      downloadReport: {
        desktop: 'Descargar reporte',
        mobile: 'Descargar',
      },
    },
    charts: {
      ByType: {
        title: 'Tipo de clasificación',
        tooltipTitle: 'Total habilidades:',
        description:
          'Revisa la distribución de todas tus habilidades, conocimientos y competencias, las cuales son clasificadas en:',
      },
      ByReuseLevel: {
        title: 'Tipo de reusabilidad',
        tooltipTitle: 'Total habilidades:',
        description:
          'Verifica la distribución del total de tus habilidades registradas según su reusabilidad, lo que indica cuán aplicable es una habilidad por su generalidad o especificidad dentro de una o más ocupaciones y sectores. Encontrarás cuatro niveles:',
      },
    },
  },
  company: {
    demo: {
      confirmAction: {
        unblocked: 'habilitar',
        blocked: 'deshabilitar',
        message:
          'Estás a punto de {action} un usuario, igualmente, una vez' +
          ' realizado el cambio puedes volver a {actionAgainst}. ¿Deseas' +
          ' continuar?',
      },
    },
    potentials: {
      title: 'Trabajadores potenciales',
      fields: {
        name: 'Detalle del perfil',
        status: 'Estado de registro',
        project: 'Proyecto',
        experiences: 'Experiencias',
        skills: 'Habilidades',
      },
      occupations: {
        label: 'Ocupación',
      },
      buttons: {
        invitation: 'Enviar nueva invitación',
      },
      skillspacks: {
        skillspacksunavailable:
          'El usuario cumple con las habilidades básicas requeridas para desempeñar el cargo',
      },
    },
    potentialsUser: {
      tabs: {
        laboralMatch: 'Coincidencias trabajador-ocupaciones',
        experiences: 'Experiencias',
        skills: 'Habilidades desarrolladas',
        personalData: 'Información personal',
      },
      tooltipRegisterTypeSkill:
        'Se detalla si la habilidad se añadió utilizando el flujo de cuestionarios o el de experiencias.',
      table: {
        laboralExperiences: 'Experiencias laborales',
        formativeExperiences: 'Experiencias formativas',
        otherExperiences: 'Otras experiencias',
        organization: 'Organización',
        period: 'Período',
        present: 'al presente',
        skills: 'Habilidades desarrolladas',
        experience: 'Experiencia',
        type: 'Tipo',
        status: 'Estado',
        matchDefault: 'Otros',
        studyLocation: 'Lugar de Estudios',
        workSkill: 'Laboral',
        educationSkill: 'Formativa',
        otherSkill: 'Otra',
        employed: 'Empleado',
        unemployed: 'No registra ocupación a la fecha',
        custom: 'Personalizada',
        skillsHasSkills: '{0}/{1}  habilidades reconocidas',
        oportunityList:
          'El usuario cumple con las habilidades básicas requeridas para desempeñar el cargo',
        tagTooltip: {
          completed:
            'El usuario cumple con todas las habilidades requeridas del curso.',
          optional:
            'El curso es sugerido como Opcional, debido a que el usuario cumple con la mayoría de habilidades requeridas.',
          required:
            'El curso es considerado Obligatorio cuando la cantidad de habilidades reconocidas se encuentran por debajo del 75% de las totales.',
          toValidate: 'Falta validar las habilidades del usuario con el curso.',
        },
      },
    },
    myWorker: {
      list: {
        title: 'Mis trabajadores',
      },
      tableIndex: {
        searchWorker: 'Buscar trabajador',
        multiselect: 'Proyecto',
      },
      alertMessage: {
        text:
          '<b>Para usuarios nuevos, su contraseña inicial será relink123.</b> Recomendamos sugerirles que la cambien al momento de ingresar a la plataforma.',
      },
      tabs: {
        laboralMatch: 'Potencial de Match',
        skillInventory: {
          title: 'Inventario de habilidades',
          charts: {
            ByType: {
              title: 'Tipo de clasificación',
              tooltipTitle: 'Total habilidades:',
              description:
                'Revisa la distribución de todas las habilidades, conocimientos y competencias registradas por su colaborador, las cuales son clasificadas en:',
            },
            ByReuseLevel: {
              title: 'Tipo de reusabilidad',
              tooltipTitle: 'Total habilidades:',
              description:
                'Verifica la distribución del total de habilidades registradas por su colaborador según su reusabilidad, lo que indica cuán aplicable es una habilidad por su generalidad o especificidad dentro de una o más ocupaciones y sectores. Encontrará cuatro niveles:',
            },
          },
        },
        experiences: 'Experiencias',
        skillsDeveloped: 'Habilidades desarrolladas',
        personalData: 'Información personal',
      },
      table: {
        laboralExperiences: 'Experiencias laborales',
        formativeExperiences: 'Experiencias formativas',
        otherExperiences: 'Otras experiencias',
        organization: 'Organización',
        period: 'Periodo',
        present: 'al presente',
        skills: 'Habilidades desarrolladas',
        experience: 'Experiencia',
        type: 'Tipo',
        status: 'Estado',
        matchDefault: 'Otros',
        studyLocation: 'Lugar de Estudios',
        workSkill: 'Laboral',
        educationSkill: 'Formativa',
        otherSkill: 'Otra',
        employed: 'Empleado',
        unemployed: 'No registra ocupación a la fecha',
        custom: 'Personalizada',
        skillsHasSkills: '{0}/{1}  habilidades reconocidas',
        oportunityList:
          'El usuario cumple con las habilidades básicas requeridas para desempeñar el cargo',
        tagTooltip: {
          completed:
            'El usuario cumple con todas las habilidades requeridas del curso.',
          optional:
            'El curso es sugerido como Opcional, debido a que el usuario cumple con la mayoría de habilidades requeridas.',
          required:
            'El curso es considerado Obligatorio cuando la cantidad de habilidades reconocidas se encuentran por debajo del 75% de las totales.',
          toValidate: 'Falta validar las habilidades del usuario con el curso.',
        },
      },
    },
  },
  invitations: {
    title: 'Invitaciones',
    subtitle: '',
    status: {
      accepted: 'Aceptada',
      pending: 'Pendiente',
      rejected: 'Rechazada',
      completed: 'Completo',
      incompleted: 'Incompleto',
      all: 'Todos',
    },
    index: {
      empty: 'No hay invitaciones',
    },
    code: {
      errors: {
        notExist: 'La invitación con ese código no existe',
        notActive: 'La invitación con ese código no está activa',
        expired: 'La invitación con ese código ha expirado',
      },
    },
    successModal: {
      worker: {
        linkText: 'Ir a Invitaciones',
        single: {
          title: '¡Yey! ¡Invitación Enviada!',
          text:
            'Se acaban de enviar la invitacion, puedes revisar el estado de esta en la sección "Invitaciones".',
        },
        massive: {
          title: '¡Yey! ¡Todos Invitados!',
          text:
            'Se acaban de enviar las invitaciones, puedes revisar el estado de estas en la sección "Invitaciones".',
        },
      },
      candidate: {
        linkText: 'Ir a Candidatos Invitados',
        single: {
          title: '¡Yey! ¡Invitación Enviada!',
          text:
            'Se acaba de enviar tu invitación, puedes revisar el estado de esta en la sección "Candidatos Invitados".',
        },

        massive: {
          title: '¡Yey! ¡Todos Invitados!',
          text:
            'Se acaban de enviar las invitaciones, puedes revisar el estado de estas en la sección "Candidatos Invitados".',
        },
      },
    },
    myWorkerAlertMessage: {
      text:
        'Los usuarios que han sido invitados y no cuenten con un email, pueden ser visualizados desde la sección "Mis trabajadores".',
      button: 'Ir a Mis Trabajadores',
    },
    massiveImportUserModal: {
      title: 'Importar lista de usuarios',
      text: 'Importar una lista de personas desde un archivo Excel:',
      uploadTextDescription: 'Carga un archivo...',
      exampleFileText: 'Ver ejemplo',
      rulesFileText: '(debe respetarse el formato)',
      cancelButton: 'Cancelar',
      sendButton: 'Cargar',
    },
    massiveImportInfoUserModal: {
      title: 'Información de carga:',
      autogenerated: 'Mail Autogenerado',
      errorText: 'Error no se pudo realizar la acción.',
      cancelButton: 'Cancelar',
      importButton: 'Importar',
    },
    validateWithoutEmail: {
      text:
        'Está a punto de crear un correo electrónico autogenerado para su usuario. Le recomendamos hacerlo solo en caso de que el usuario no tenga una dirección de correo electrónico. <b>¿Está seguro de querer continuar?</b>',
      goBackButton: 'Volver',
      continueButton: 'Continuar',
    },
    invitationModal: {
      importMassiveUserButton: 'Importar una lista de usuarios',
      cancelButton: 'Cancelar',
      anotherInvitation: 'Añadir y crear otro usuario',
      invitationButton: 'Invitar persona',
    },
    invitationAlertMessage: {
      text:
        'Los usuarios que han sido invitados y no cuenten con un email, pueden ser visualizados desde la sección "Mis trabajadores".',
      button: 'Ir a Mis Trabajadores',
    },
    confirmRegisterUserWithoutEmailModal: {
      title: '¡Yey! ¡Nuevo usuario!',
      text:
        '<strong>¡Recuerda que este usuario cuenta con un correo electrónico autogenerado y es importante que le entregues su información!</strong> Para más detalles, puedes dirigirte al perfil del trabajador en la sección "Mis trabajadores".',
      cancelButton: 'Cerrar',
      finalizeButton: 'Ir a mis trabajadores',
    },
    confirmRegisterUserWithEmailModal: {
      title: '¡Yey! Invitación Enviada!',
      text:
        'Se acaba de enviar tu invitación, puedes revisar el estado de esta en la sección "{0}".',
      cancelButton: 'Cerrar',
      finalizeButton: 'Ir a invitaciones',
    },
    confirmRegisterMassiveUser: {
      title: '¡Yey! Todos invitados!',
      text:
        'Se acaban de enviar las invitaciones, puedes revisar el estado de estas desde el módulo de tu proyecto.',
      cancelButton: 'Volver',
    },
  },
  meetings: {
    detail: {
      title: 'Detalle de Solicitud',
    },
    attributes: {
      status: {
        unreaded: 'No leido',
        answered: 'Completado',
        read: 'En Proceso',
        pending: 'Pendiente',
      },
    },
  },
  opportunities: {
    index: {
      title: 'Mis Oportunidades',
      subtitle: {
        completed: {
          text:
            'Te presentamos aquellas ocupaciones de futuro que tienen mayor coincidencia con tu perfil laboral, considerando las experiencias y las habilidades que registraste en esta plataforma.',
        },
        incompleted: {
          important: '¡Aún no has completado tus tareas!',
          text:
            'Cuando lo hagas podremos mostrarte todas aquellas ocupaciones de futuro que se adecuan mejor a tus habilidades y experiencias.',
        },
      },
      inProcess: 'En proceso',
    },
    reskill: {
      title: 'Mis Pilotos de reconversion laboral',
      subtitle: {
        completed: {
          text:
            'Te presentamos aquellas ocupaciones que tienen mayor coincidencia con tu perfil y que podrías optar a futuras capacitaciones.',
        },
        incompleted: {
          important: '¡Aún no has completado tus tareas!',
          text:
            'Cuando lo hagas podremos mostrarte todas aquellas ocupaciones a las cuales podrías optar a una futura capacitación!',
        },
      },
    },
    work: {
      title: 'Mis Oportunidades de reconversion laboral',
      subtitle: {
        completed: {
          text:
            'Te presentamos aquellas ocupaciones del futuro que tienen mayor coincidencia con tu perfil laboral. ',
        },
        incompleted: {
          important: '¡Aún no has completado tus tareas!',
          text:
            'Cuando lo hagas podremos mostrarte todas aquellas ocupaciones de futuro que se adecuan mejor a tus habilidades y experiencias.',
        },
      },
      detail: {
        requirements: 'Requisitos del Piloto',
        more: 'ver más',
      },
    },
    detail: {
      title: 'Detalle de oportunidad',
      subtitle: {
        important: 'Te presentamos los resultados de tu cuestionario para {0},',
        text: 'los cuales te ayudarán a alcanzar tu  máximo potencial.',
      },
      subtitleUnemployed:
        'Te presentamos aquellas ocupaciones de futuro que tienen mayor coincidencia con tu perfil laboral, considerando las experiencias y las habilidades que registraste en esta plataforma.',
      coincidence: {
        label: 'coincidencia con tu perfil',
        tooltip:
          'Este es tu % de coincidencia con la oportunidad de reconversión, revisa en la tabla inferior las líneas formativas que te ayudará a completar la brecha.',
      },
      adequacy: {
        label: 'Adecuación del perfil',
        value:
          'Revisa la distribución de todas las habilidades y conocimientos registradas.',
      },
      opportunityTable: {
        titleDetails: 'Detalle de las ocupaciones',
        titlePercentage: '% de adecuación al perfil',
        sectionNoOpportunities: {
          text:
            'Aún no encontramos tu match perfecto :( continúa registrando experiencias para obtener nuevas oportunidades.',
        },
      },
      description: {
        label: 'Descripción del perfil',
      },
      courseCount:
        'Requieres de {total_hours} horas de capacitación para' +
        ' completar tu' +
        ' brecha de reconversión laboral',
      skillCount: '<p>Cuentas con <b>{0}</b> de {1} habilidades requeridas</p>',
      employedPeople: 'Personas Ocupadas',
      employedWomen: 'Son Mujeres',
      employedAge: 'Edad Promedio',
      employedAgeValue: '{0} años',
      skillsTable: {
        hierarchy: {
          label: 'Líneas formativas',
          detailField: 'Detalle',
          timeField: 'Horas restantes',
          category: 'Categoría',
        },
        missingSkills: {
          label: 'Tus habilidades faltantes',
        },
        skills: {
          label: 'Tus habilidades',
        },
      },
      skillsPacks: {
        skillspacksunavailable:
          '¡Cumples con las habilidades básicas requeridas para desempeñar el cargo!',
      },
      alertClose: {
        title: '¡Advertencia!',
        subtitle: '¿Estás de acuerdo en salir?',
        text:
          'Si sales sin antes publicar la información, perderás los datos que ingresaste, de todos modos, recuerda que puedes volver a ingresar una ocupación cuantas veces quieras.',
        btnConfirm: 'Salir de todos modos',
        btnReject: 'Cancelar',
      },
    },
    messages: {
      detailNumberCourses:
        'Número de horas requeridas de capacitación para completar la brecha según la oportunidad de reconversión identificada.',
    },
  },
  requiredOccupations: {
    tabs: {
      potentialWorkers: 'Trabajadores potenciales',
      skills: 'Habilidades',
      detail: 'Detalles de la Ocupación',
    },
    tables: {
      potentialWorkers: {
        profile: 'Perfil del Trabajador/a',
        record: 'Registro histórico',
        recordTooltip:
          'Corresponde al registro total de experiencias, tanto laborales como formativas, inscritas por el usuario y su total de habilidades adquiridas en dichas experiencias.',
        match: '% de coincidencia con la ocupación',
        moreMatches: 'Ver más coincidencias',
        employed: 'Empleado',
        unemployed: 'No registra ocupación a la fecha',
        experiences: 'Experiencias',
        skills: 'Habilidades',
        matches: 'Coincidencias',
      },
      skills: {
        optional: 'Habilidad Opcional',
        mandatory: 'Habilidad Obligatoria',
      },
    },
    detail: {
      labels: {
        publish: 'Publicar',
        startDate: 'Fecha de creación',
        skills: 'Habilidades',
        creator: 'Creador',
        publisher: 'Publicador',
        lastUpdated: 'Última actualización',
        report: 'Reporte de Ocupación',
        download: 'Descargar',
      },
      tabs: {
        main: {
          information: 'Información',
          occupation: 'Ocupación',
          project: 'Nombre de Proyecto',
          area: 'Área',
          description: 'Descripción',
          status: 'Estatus',
          internalId: 'Id Interno',
        },
        skills: {
          all: 'Todas',
          optional: 'Opcional',
          mandatory: 'Obligatoria',
        },
      },
      general: {
        published: 'Publicada',
        unpublished: 'Sin publicar',
      },
    },
    new: {
      fields: {
        vacancies: 'Vacantes',
        name: 'Nombre de Proyecto',
      },
      modal: {
        prompt: `Para incorporar una nueva ocupacíón, selecciona del listado aquella que más se ajuste a sus necesidades.
         Una vez que hayas seleccionado la ocupación, indica el nombre del proyecto y la cantidad de trabajadores que tu
         organización requiere en este rol.`,
      },
    },
  },
  customOccupationDetail: {
    notification: {
      edit:
        'Recuerda: El modificar un perfil ya publicado afectará la brecha de reconversión de los usuarios que hicieron match.',
    },
    tabs: {
      skills: 'Habilidades',
      detail: 'Perfil Base',
    },
    tables: {
      potentialWorkers: {
        profile: 'Perfil del Trabajador/a',
        record: 'Registro histórico',
        recordTooltip:
          'Corresponde al registro total de experiencias, tanto laborales como formativas, inscritas por el usuario y su total de habilidades adquiridas en dichas experiencias.',
        match: '% de coincidencia con la ocupación',
        moreMatches: 'Ver más coincidencias',
        employed: 'Empleado',
        unemployed: 'No registra ocupación a la fecha',
        experiences: 'Experiencias',
        skills: 'Habilidades',
        matches: 'Coincidencias',
      },
      skills: {
        optional: 'Habilidad Opcional',
        mandatory: 'Habilidad Obligatoria',
      },
    },
    detail: {
      labels: {
        publish: 'Publicar',
        startDate: 'Fecha de incorporación',
        skills: 'Habilidades',
        creator: 'Creador',
        publisher: 'Publicador',
        lastUpdated: 'Última actualización',
        report: 'Reporte de Ocupación',
      },
      actionButtons: {
        download: 'Descargar Reporte',
        save: 'Guardar',
        publish: 'Publicar',
      },
      tabs: {
        main: {
          information: 'Información',
          occupation: 'Nombre de Ocupación/Cargo',
          occupationBase: 'Perfil Base',
          occupationOrigin: 'Perfil Origen',
          area: 'Área',
          description: 'Descripción',
          status: 'Estatus',
          company: 'Empresa',
        },
        skills: {
          filters: {
            search: 'Buscar...',
            select: 'Todas las categorías ESCO',
          },
          added: {
            title: 'Habilidades agregadas',
          },
          origin: {
            title: 'Habilidades del perfil base seleccionadas',
            textInformation:
              'El perfil creado viene con las habilidades seleccionadas del perfil base.',
          },
          addSkillsButton: 'Agregar habilidad',
          saveSkillsButton: 'Guardar cambios',
        },
      },
      general: {
        published: 'Publicada',
        unpublished: 'Sin publicar',
      },
      modalAlertUnsaved: {
        title: '¡Atención!',
        subtitle: 'Aún no guardas tu progreso',
        text:
          '¿Deseas continuar luego? Te recomendamos guardar tu progreso y retomar en otro momento, de no ser así perderas los datos que ingresaste',
        btnConfirm: 'Guardar progreso y salir',
        btnReject: 'Salir de todos modos',
      },
      modalAlertDelete: {
        title: '¡Atención!',
        subtitle: '¿Quieres eliminar este perfil?',
        text:
          'Estás a punto de eliminar este perfil, ten en cuenta que si continúas perderás toda la información definitivamente y, ya no estará disponible para la empresa ni para los empleados.',
        btnConfirm: 'Continuar y eliminar perfil',
        btnReject: 'Volver',
      },
      modelAlertPendingSkills: {
        title: '¡Alto! ¡No tan rápido!',
        text:
          'Aún tienes pendiente validar la <strong>esencialidad</strong> de algunas habilidades.',
        btnReject: 'Volver',
      },
      modelAlertLeave: {
        title: '¿Deseas abandonar el sitio?',
        text: 'Tu perfil ya ha sido creado, puedes retomar en otro momento',
        btnConfirm: 'Abandonar',
        btnReject: 'Cancelar',
      },
      modelAlertLeavePublish: {
        title: '¿Deseas abandonar el sitio?',
        text: '¿Descartar los cambios no guardados?',
        btnConfirm: 'Descartar',
        btnReject: 'Cancelar',
      },
      modalConfirmPublish: {
        title: '¡Yey! ¡Todo Listo!',
        subTitle: 'Ocupación Publicada',
        text:
          'La empresa <strong>{0}</strong> ya podrá ver reflejada la nueva ocupación en su sección de “Potencial de match”.',
        finalize: 'Finalizar',
      },
      modalSummaryPublish: {
        title: 'Resumen de Ocupación Personalizada',
        companyName: 'Empresa:',
        basicProfile: 'Perfil Base:',
        occupationName: 'Nombre de ocupación:',
        description: 'Descripción:',
        addedSkills: 'Habilidades agregadas',
        deletedSkills: 'Habilidades eliminadas',
        baseProfileSkills: 'Habilidades del perfil base seleccionadas',
        btnCancel: 'Volver',
        btnPublish: 'Publicar',
      },
      modalConfirmUpdatePublish: {
        title: '¡Todo listo!',
        text: 'Los cambios se verán reflejados en la empresa y sus empleados',
        btnReturn: 'Volver',
        btnCustomOccupation: 'Ir a "Ocupaciones Personalizadas"',
      },
    },
    new: {
      fields: {
        vacancies: 'Vacantes',
        name: 'Nombre de Proyecto',
      },
      modal: {
        prompt: `Para incorporar una nueva ocupacíón, selecciona del listado aquella que más se ajuste a sus necesidades.
         Una vez que hayas seleccionado la ocupación, indica el nombre del proyecto y la cantidad de trabajadores que tu
         organización requiere en este rol.`,
      },
    },
    modals: {
      addSkills: {
        title: 'Agregar habilidades',
        description: 'Escribe una palabra simple o compuesta',
        successButton: 'Agregar',
        cancelButton: 'Cancelar',
        existSkillMessage:
          'Si estás buscando las siguientes habilidades, estas ya se encuentran agregadas:',
      },
      update: {
        title: 'Editar ocupación',
        company: 'Empresa:',
        baseOccupation: 'Perfil base:',
        name: 'Nombre Ocupación/Cargo:',
        description: 'Descripción:',
        status: 'Estatus:',
        cancel: 'Cancelar',
        save: 'Guardar Cambios',
        delete: 'Eliminar Perfil',
      },
    },
    addSkills: {
      title: 'Agregar habilidades',
      description:
        'Te sugerimos habilidades con base en ocupaciones que pertenecen a la misma familia del perfil base de tu nueva ocupación.',
      selectedSkills: 'Habilidades seleccionadas',
      subtitle:
        'Selecciona todas las habilidades que coincidan con la ocupación.',
      suggestedSkills: {
        title: 'Sugerencias basadas en tu ocupación:',
      },
    },
    filters: {
      title: 'Filtros:',
      typology: 'Tipología: ',
      essentiality: 'Esencialidad: ',
    },
  },
  footer: {
    doubtsLabel: '¿Tienes dudas?',
    disableLabel:
      'Si quieres tomarte un descanso de Relink, puedes solicitar la inhabilitación de tu cuenta a:',
    helpLabel: '¿Necesitas ayuda?',
    faqLink: 'Preguntas frecuentes',
    termsLink: 'Condiciones de uso',
    privacyLink: 'Política de privacidad',
    dataLink: 'Política de almacenamiento de datos',
  },
  navbar: {
    menu: {
      profile: 'Mi Perfil',
      logout: 'Cerrar sesión',
    },
    adminMenu: {
      title: 'Empresas',
      subtitle: 'Recién creadas',
      moreCompanies: 'Buscar más empresas',
      backToAdminRelink: 'Regresar admin Relink',
      companySearchModal: {
        title: 'Empresas',
        placeholder: 'Buscar empresa...',
        button: 'Acceder',
        noResults: {
          title:
            '¡Ups! No se encontraron sugerencias para tu búsqueda. Te recomendamos:',
          first:
            '· Comprueba que todas las palabras estén escritas correctamente.',
          second: '· Intenta con diferentes palabras clave.',
          third: '· Utiliza palabras claves más generales.',
        },
      },
    },
  },
  misc: {
    form: {
      selectOption: 'Seleccionar',
      deselectOption: 'Deseleccionar',
      selectedOption: 'Seleccionado',
    },
    messages: {
      wishEnd: '¿Quieres terminarlas?',
      success: 'Acción terminada correctamente',
      error: 'Ha ocurrido un error inesperado.',
      copiedToClipboard: 'Copiado al portapapeles',
      loading: 'Cargando...',
    },
    errors: {
      mustSelectOption: 'Debes seleccionar una opción',
      genericError: 'Ocurrio un error, intente de nuevo mas tarde',
      emptyField: 'Tienes campos obligatorios sin completar',
    },
    buttons: {
      detail: '+ Detalles',
      view: 'Visualizar',
      generateReport: {
        occupation: {
          meta: 'Descargar Perfiles Meta',
          findOne: 'Descargar Reporte Ocupación',
        },
      },
      seeMore: 'Ver más',
      save: 'Guardar',
      submit: 'Enviar',
      close: 'Cerrar',
      continue: 'Continuar',
      previous: 'Anterior',
      back: 'Volver',
      search: 'Buscar',
      confirm: 'Confirmar',
    },
    table: {
      actions: 'Acciones',
    },
    pagination: {
      next: 'Siguiente',
      previous: 'Anterior',
      title: 'Página',
      current: 'Actual',
    },
  },
  register: {
    form: {
      title: 'Completa tus datos para crear tu perfil',
      firstName: {
        name: 'nombre',
        label: 'Nombre',
      },
      lastName: {
        name: 'apellidos',
        label: 'Apellidos',
      },
      rut: {
        label: 'RUT',
        placeholder: '11111111-1',
      },
      email: {
        name: 'correo electrónico',
        label: 'Correo electrónico',
      },
      gender: {
        name: 'género',
        label: 'Género',
        placeholder: 'Selecciona tu género',
      },
      educationLevel: {
        name: 'nivel educacional',
        label: 'Nivel educacional',
        placeholder: 'Selecciona tu nivel educacional',
      },
      birthdate: {
        name: 'fecha de nacimiento',
        label: 'Fecha de nacimiento (dd/mm/aaaa)',
        placeholder: 'DD/MM/AAAA',
      },
      country: {
        name: 'country',
        label: 'País',
        placeholder: 'Selecciona tu país',
      },
      region: {
        name: 'región',
        label: 'Región',
        placeholder: 'Selecciona tu región',
      },
      comune: {
        name: 'comuna',
        label: 'Comuna',
        placeholder: 'Selecciona tu comuna',
      },
      password: {
        name: 'contraseña',
        label: 'Crea una contraseña',
      },
      confirm: {
        name: 'repetir contraseña',
        label: 'Repite tu contraseña',
      },
      terms: {
        first: 'Acepto los',
        second:
          'términos de uso, las políticas de privacidad y las políticas de almacenamiento de datos',
        third: 'de este sitio web.',
      },
      provideData: {
        first: 'Acepto las',
        second: 'condiciones para el tratamiento de mis datos',
        third: 'de este sitio web.',
      },
      suscription:
        'Quiero recibir las novedades de Relink en mi correo electrónico.',
      submit: 'Crear perfil',
      next: 'Siguiente',
      cities: 'Estado/Región/Departamento',
      education: 'Nivel educacional',
      document_number: 'Nº documento de identidad/pasaporte',
      educationForeignLevel: {
        name: 'nivel educacional',
        label: 'Nivel educacional',
        placeholder: 'Ejemplo: Secundaria',
      },
    },
    errors: {
      general:
        'Ocurrió un error al registrarse, si el problema persiste ponte en contacto con contacto@relink.cl',
      emailExists: 'El correo electrónico ya esta en uso',
    },
    text: {
      addInfo:
        'Ingresa información sobre tu formación y experiencias laborales',
      howRelinkUseInfo:
        'Con esta información Relink te orientará sobre los posibles caminos de desarrollo laboral',
    },
    confirmationModal: {
      title: 'Estás a un paso de crear tu perfil en Relink',
      description:
        'Te hemos enviado un mensaje a tu correo electrónico para que confirmes la creación de tu perfil.',
      button: 'Entendido',
    },
  },
  howWorking: {
    sections: [
      {
        id: 'perfiles',
        identificatorText: 'Diseño de perfiles ocupacionales',
        title:
          'Diseñamos los perfiles ocupacionales que necesitan las industrias y organizaciones',
        elements: [
          {
            text:
              'Relink responde a las nuevas demandas de habilidades en perfiles ocupacionales mediante un proceso de diseño y desarrollo de perfiles ocupacionales. Esto contempla la identificación, definición y respaldo por investigaciones, expertos y revisión de tendencias nacionales e internacionales, y sus bolsas de empleo.',
          },

          {
            text:
              'Aquí se identifican aquellas líneas productivas donde se requiere trabajar, tomando en consideración también las oportunidades de reconversión o especialización dentro y fuera del sector. El proceso cuenta con la participación activa de las empresas, para que resultados respondan a las necesidades de fortalecimiento del capital humano desde su propia perspectiva y desafíos.',
          },
        ],
        image: {
          src: 'como-funciona-relink-1',
          alt: 'como funciona relink 1',
        },
        detail: {
          title: 'Diseño de perfiles ocupacionales',
          steps: [
            'Confeccionamos perfiles ocupacionales que necesitan las industrias y los sectores productivos considerando los aspectos necesarios para el correcto desempeño de las personas.',
          ],
        },
      },
      {
        id: 'identificamos-habilidades',
        identificatorText: 'Identificamos Habilidades',
        title: 'Identificamos habilidades a partir de la experiencia laboral',
        elements: [
          {
            text:
              'Las organizaciones se adaptan con mayor facilidad a los cambios y desafíos cuando identifican las habilidades con las que cuentan sus colaboradores, pero es difícil para las personas reconocer sus propias habilidades para el trabajo. Sin embargo, a partir de su formación y su trayectoria laboral, es posible evaluar si un trabajador ha desarrollado las habilidades requeridas para los nuevos empleos.',
          },

          {
            text:
              'Para esto, Relink solicita al trabajador que conteste una serie de preguntas sobre su formación y los trabajos en los que se ha desempeñado. Luego la plataforma contrasta esta información con un inventario con más de 14.000 habilidades identificadas y adaptadas al contexto chileno por Relink, a partir de la Clasificación Europea de Capacidades, Competencias, Cualificaciones y Ocupaciones (ESCO), desarrollada por la Unión Europea.',
          },
        ],
        image: {
          src: 'como-funciona-relink-2',
          alt: 'como funciona relink 2',
        },
        detail: {
          title: 'Herramientas de Relink para identificar habilidades',
          steps: [
            'Sistema de identificación de habilidades de los trabajadores a partir de su formación y experiencias laborales y además contamos con un panel de control permite hacer seguimiento al avance de los trabajadores de la empresa en la plataforma.',
          ],
        },
      },
      {
        id: 'oportunidades-reconversion',
        identificatorText: 'Oportunidades de Reconversión',
        title: 'Uso de tecnología para orientar la reconversión laboral',
        elements: [
          {
            text:
              'Gracias al uso de su plataforma digital basada en algoritmos, Relink cruza la información detectada sobre las habilidades e intereses de un trabajador con los requerimientos del mercado laboral, estableciendo el potencial de reconversión laboral de esta persona hacia nuevos tipos de empleos.',
          },

          {
            text:
              'Este análisis se sustenta en perfiles de ocupaciones emergentes desarrollados por Relink a partir de información levantada en el mercado laboral chileno y las habilidades identificadas sobre la clasificación ESCO. Con esta información, las empresas podrán identificar las necesidades de capacitación para la reconvertir a sus trabajadores y enfrentar los nuevos desafíos de la organización.',
          },
        ],
        image: {
          src: 'como-funciona-relink-3',
          alt: 'como funciona relink 3',
        },
        detail: {
          title:
            'Tecnología para contrastar el talento actual y necesidades futuras',
          steps: [
            'Los algoritmos de la plataforma de Relink permiten contrastar las habilidades de los trabajadores con los perfiles ocupacionales que requiere la empresa.',
          ],
        },
      },
      {
        id: 'planes-capacitacion',
        identificatorText: 'Planes de Capacitación',
        title: 'Información para diseñar planes de capacitación',
        elements: [
          {
            text:
              'A partir del análisis sobre las habilidades de sus trabajadores, Relink ofrece a las empresas orientaciones sobre planes formativos ajustados a la realidad de cada organización.',
          },

          {
            text:
              'Con esta información, las empresas pueden diseñar planes de capacitación que ayuden a sus trabajadores a desarrollar las habilidades que demandan las nuevas ocupaciones, aprovechando los beneficios de la Franquicia Tributaria de SENCE.',
          },
        ],
        image: {
          src: 'como-funciona-relink-4',
          alt: 'como funciona relink 4',
        },
        detail: {
          title: 'Apoyo en la toma de decisiones',
          steps: [
            'Orientación para gestionar la capacitación a través de la Franquicia Tributaria de SENCE.',
          ],
        },
      },
    ],
    firstCta: {
      title: 'Prepara a tu empresa para la transformación del mercado laboral',
      description:
        'Desde relink acompañamos a tu empresa en este proceso, con herramientas digitales especialmente diseñadas para apoyar la reconversión de tu capital humano.',
      btn: {
        text: 'Solicita una reunión',
        link: '/agenda-una-reunion',
      },
    },
    cta: {
      title: 'Prepara a tu empresa para la transformación tecnológica',
      text:
        'Desde relink acompañamos a tu empresa en este proceso, con herramientas digitales especialmente diseñadas para apoyar la reconversión de tu capital humano.',
      link: {
        text: 'Solicita una reunión',
        url: '/agenda-una-reunion',
      },
    },
  },
  faqs: {
    sections: [
      {
        id: 'preguntas-generales',
        identificatorText: 'Preguntas Generales',
        title: 'Preguntas Generales',
        questions: [
          {
            question: '¿Qué es Relink?',
            answers: [
              'Relink es una plataforma de orientación laboral, que busca conectar a las personas y las empresas con las nuevas ocupaciones que están surgiendo gracias a la transformación de la economía y el empleo en diversos ámbitos, impulsada por la tecnología.',
            ],
          },
          {
            question: '¿A quiénes está dirigido Relink?',
            answers: [
              'Relink está dirigido a trabajadores que necesitan renovar sus habilidades para mantenerse, desarrollarse o reincorporarse en un mercado laboral en permanente evolución.',
              'Relink está dirigido a empresas que están cambiando su demanda de habilidades internas producto de la transformación tecnológica o digital y necesitan reconvertir a sus colaboradores.',
              'En una primera etapa estamos enfocados en las áreas de perfiles digitales, mantenimiento y manufactura avanzada (incluye logística).',
            ],
          },
          {
            question: '¿El uso de la Relink tiene costo?',
            answers: [
              'No, Relink es una plataforma gratuita y de servicio público. Esto significa que ni las personas ni las empresas deben pagar por su uso.',
            ],
          },
        ],
      },
      {
        id: 'personas',
        identificatorText: 'Personas',
        title: 'Personas',
        questions: [
          {
            question: '¿Qué me ofrece Relink?',
            answers: [
              'Si te inscribes en forma individual en Relink, la plataforma te permite crear un perfil donde podrás registrar tu formación y experiencias laborales, así como validar aquellas habilidades que has desarrollado. Esta información le permite a Relink entregar un reporte con aquellas ocupaciones de futuro que más se acercan a tu perfil.',
            ],
          },
          {
            question:
              '¿Cómo identifican cuáles tipos de trabajo se ajustan mejor a mi perfil?',
            answers: [
              'Relink identifica las habilidades de los trabajadores a partir de los datos que estos ingresan a la plataforma sobre su formación y sus experiencias laborales. Esta información es contrastada luego con las habilidades requeridas por las nuevas ocupaciones de futuro, lo que permite establecer qué tanta coincidencia existe entre el perfil de una persona y una ocupación determinada. Este resultado orientará a las personas acerca de aquellas ocupaciones que se acercan más a su perfil y a las que podrían reorientarse con mayor facilidad.',
            ],
          },
          {
            question:
              '¿Cuánto tiempo me tomará registrar mi información para obtener estos resultados?',
            answers: [
              'Completar la información sobre formación, experiencias laborales y habilidades toma alrededor de 30 minutos.',
            ],
          },
          {
            question: '¿Qué es una habilidad y por qué es importante?',
            answers: [
              'Una habilidad es la capacidad de aplicar conocimientos teóricos y prácticos para completar una tarea y resolver un problema. Las habilidades pueden ser de tipo cognitivo (uso de pensamiento lógico, intuitivo o creativo) o práctico (incluyendo destrezas manuales y el uso de métodos, materiales, herramientas e instrumentos). Las habilidades son importantes porque permiten describir de mejor manera los requerimientos de un determinado empleo, así como las capacidades que un trabajador ha desarrollado a lo largo de su trayectoria.',
            ],
          },
          {
            question: '¿Puedo postular a trabajos a través de Relink?',
            answers: [
              'No. Relink es una plataforma de orientación laboral, no una bolsa de empleos. Esto significa que te podemos orientar acerca de los tipos de  trabajos de futuro que más se ajustan a tus habilidades y experiencias, pero no publicamos avisos sobre ofertas específicas de trabajo.',
            ],
          },
          {
            question: '¿Me puedo capacitar a través de Relink?',
            answers: [
              'No, Relink no ofrece directamente servicios de capacitación. Sin embargo, la orientación que entrega la plataforma es útil para que los trabajadores puedan enfocar de mejor manera sus necesidades de capacitación.',
            ],
          },
          {
            question: 'Soy extranjero, ¿puedo crear un perfil en Relink?',
            answers: [
              'Sí, Relink está dirigido a todos los trabajadores que residen en Chile.',
            ],
          },
        ],
      },
      {
        id: 'empresas',
        identificatorText: 'Empresas',
        title: 'Empresas',
        questions: [
          {
            question: '¿Qué le ofrece Relink a mi empresa?',
            answers: [
              'Relink le ofrece a las empresas la oportunidad de evaluar el talento presente en sus equipos, en función de los desafíos que la transformación tecnológica plantea a su organización. En concreto, permite evaluar el potencial de reconversión de sus trabajadores a las nuevas ocupaciones, a partir del análisis de su formación, experiencias, habilidades e intereses.',
            ],
          },
          {
            question: '¿Cuáles son los beneficios de ocupar Relink?',
            answers: [
              'Relink es un servicio gratuito que le ayudará a tu empresa a tomar decisiones basadas en evidencia. Así, la organización podrá enfocar mejor sus esfuerzos de capacitación y reconversión para poder hacer frente a los desafíos que impone la transformación de la economía y el empleo debido a la tecnología.',
            ],
          },
          {
            question: '¿Qué es la reconversión laboral?',
            answers: [
              'La reconversión laboral es la reorientación de un trabajador desde su empleo actual hacia otro de mayor sofisticación o diferente, para el cual no cuenta con todas las habilidades necesarias.',
              'Esto es necesario cuando el empleo original de un trabajador está en riesgo de ser automatizado y ya no es requerido en el mercado laboral. También cuando el empleo original de un trabajador aumenta su demanda de habilidades.',
              'La reconversión implica un plan de formación para que el trabajador pueda desarrollar las habilidades que no tiene y necesita para desempeñar el nuevo empleo.',
            ],
          },
          {
            question:
              '¿Qué significa que Relink ofrece una reconversión laboral inteligente?',
            answers: [
              'Significa que las propuestas de reconversión que Relink ofrece están basadas en el análisis de los requerimientos futuros del mercado laboral chileno, así como en el uso de Inteligencia Artificial, para determinar el nivel de coincidencia entre el perfil de un trabajador y una ocupación determinada.',
            ],
          },
          {
            question:
              '¿Cómo se asegura Relink de orientar a los trabajadores hacia ocupaciones con reales posibilidades de empleo?',
            answers: [
              'La orientación que Relink entrega a trabajadores y empresas se basa en la continua observación de la realidad del mercado laboral chileno y la demanda por ocupaciones emergentes vinculadas con la transformación tecnológica. Actualmente trabajamos con más de 30 perfiles de ocupaciones en tres grandes ámbitos que se pueden desarrollar en diversas industrias: perfiles digitales, mantenimiento y manufactura avanzada (incluye logística).',
            ],
          },
        ],
      },
    ],
  },
  companies: {
    requiredOccupations: {
      title: 'Potencial de match',
      modalButton: 'Agregar Ocupación',
      downloadExcel: 'Descargar',
      createRequiredOccupation: {
        title: 'Crear ocupación',
        description: `Para incorporar una nueva ocupacíón, selecciona del listado aquella que más se ajuste a sus necesidades.
         Una vez que hayas seleccionado la ocupación, indica el nombre del proyecto y la cantidad de candidatos que tu
         piloto requiere en este rol.`,
        primaryButton: 'Crear ocupación',
        secondaryButton: 'Cancelar',
        occupationInput: {
          placeholder: 'Escribe un cargo/ocupación para buscar',
          label: 'Cargo/Ocupación',
        },
        projectInput: {
          placeholder: '',
          label: 'Nombre proyecto',
        },
        vacanciesInput: {
          placeholder: '',
          label: 'Cantidad de vacantes',
        },
        messages: {
          success: 'Se ha agregado la ocupación correctamente',
          registered: 'La ocupación ya estaba registrada',
          error: 'Ocurrió un error al registrar la ocupación',
        },
      },
      updatedRequiredOccupation: {
        description: `Para editar una ocupación, selecciona del listado aquella que más se ajuste a sus necesidades. Una vez que hayas seleccionado la ocupación, indica el nombre del proyecto y la cantidad de candidatos que tú piloto requiere en este rol.`,
      },
    },
  },
  homepage: {
    companiesWhoTrust: {
      title:
        'Soñamos con poner en valor las habilidades de las personas para las necesidades futuras del mercado laboral.',
      description:
        'Relink es fruto de una alianza de instituciones públicas y privadas en Chile que responde a la transformación del mercado laboral.',
      link: 'Conoce quienes somos Relink',
    },
    messageSection: {
      title: 'Explora tu futuro laboral en tres simples pasos',
      messages: [
        {
          icon: {
            src: '/img/home/crea.svg',
            alt: 'crea tu perfil icon',
          },
          title: 'Crea tu perfil',
          description:
            'Relink te ayuda a diseñar tu futuro laboral utilizando tus habilidades e intereses como base',
        },
        {
          icon: {
            src: '/img/home/registra.svg',
            alt: 'registra habilidades icon',
          },
          title: 'Registra tu experiencia',
          description:
            'Conocer tu formación y experiencia laboral nos ayudará a presentarte las trayectorias laborales más apropiadas para ti',
        },
        {
          icon: {
            src: '/img/home/oportunidad.svg',
            alt: 'oportunidades icon',
          },
          title: 'Descubre tus oportunidades',
          description:
            'Te mostraremos cuáles son las nuevas ocupaciones que se ajustan mejor a tu perfil y habilidades',
        },
      ],
    },
    mainSection: {
      step1: {
        title: 'reconócete',
        description:
          'La experiencia que has acumulado a lo largo de tu carrera es la base de tu futuro laboral. Relink te ayuda a reconocer aquellas habilidades que has desarrollado y que son requeridas en los nuevos puestos de trabajo.',
        link: {
          label: 'Identifica tus habilidades',
          url: '/registro',
        },
      },
      step2: {
        title: 'reoriéntate',
        description:
          'Te presentamos los nuevos tipos de trabajo en los que te podrías desempeñar, de acuerdo a tu formación, experiencia previa y desafíos de aprendizaje.',
        link: {
          label: 'Conoce nuestra propuesta',
          url: '/nuestra-propuesta',
        },
      },
      step3: {
        title: 'reconéctate',
        description:
          'Durante los próximos años se crearán más de 2 millones de nuevos puestos de trabajo. Sintonízate con aquellas nuevas ocupaciones que requieren personas con experiencias como la tuya.',
        link: {
          label: 'Inicia tu transformación laboral',
          url: '/registro',
        },
      },
    },
    components: {
      aboutUs: {
        title: 'Conoce Relink Empresas',
        description:
          'Relink Empresas es un servicio gratuito que ayuda a las organizaciones a identificar y gestionar las habilidades de sus colaboradores',
        cta: 'Conoce más',
      },
      purposeStats: {
        title: 'Nuestro respaldo',
        description:
          'Nuestro análisis se sustenta en el desarrollo de más de 150 perfiles ocupacionales a partir del trabajo con empresas, gremios y la información disponible del mercado laboral. <br /> La plataforma de Relink utiliza la información de MapHa, taxonomía que clasifica las ocupaciones e identifica las habilidades para el futuro del trabajo, que permite disponer de una base de datos con más de 3.000 ocupaciones y 14.000 habilidades para procesos de gestión del capital humano.',
        stats: {
          first: {
            value: '30',
            entity: 'Perfiles de empleo',
          },
          second: {
            value: '+12.000',
            entity: 'Habilidades identificadas',
          },
        },
      },
    },
  },
  homeCompany: {
    messageSection: {
      title:
        'Ayudamos a tu organización a enfrentar los desafíos de la transformación del mercado laboral',
      messages: [
        {
          icon: {
            src: '/img/home/identify.svg',
            alr: 'identify icon',
          },
          description:
            'Identificamos las habilidades de los trabajadores a través de la plataforma de Relink',
        },
        {
          icon: {
            src: '/img/home/analitics.svg',
            alr: 'analitics icon',
          },
          description:
            'Analizamos las habilidades recogidas de los trabajadores con data sobre los requerimientos actuales y futuros del mercado laboral',
        },
        {
          icon: {
            src: '/img/home/target.svg',
            alr: 'target icon',
          },
          description:
            'Orientamos a las organizaciones para tomar decisiones con información basada en evidencia',
        },
      ],
    },
    mainSection: [
      {
        title: 'reevalúa el talento existente en tu empresa',
        img: {
          src: 'home-empresas-1',
          alt: 'reevalua image',
        },
        imgBackground: {
          src: require(`~/assets/images/homepage/point-lines/background-dots-sm.jpg`),
          alt: 'puntos background',
        },
        imgBottom: {
          srcDesktop: require(`~/assets/images/homepage/point-lines/background-dots-lines-1.jpg`),
          srcMobile: '/img/home/line-bottom-1.svg',
          alt: 'puntos lineas',
        },
        list: [
          'Identifica las habilidades de tus colaboradores.',
          'Accede a un inventario detallado de habilidades y experiencias.',
          'Analiza talentos e intereses.',
          'Explora el potencial de especialización o reconversión de las personas.',
        ],
        button: {
          label: 'Conoce más detalles',
          url: '/como-funciona',
        },
      },
      {
        title: 'repotencia las capacidades de tus colaboradores',
        img: {
          src: 'home-empresas-2',
          alt: 'repotencia image',
        },
        imgBackground: {
          src: require(`~/assets/images/homepage/point-lines/background-dots-md.jpg`),
          alt: 'puntos background',
        },
        imgBottom: {
          srcDesktop: require(`~/assets/images/homepage/point-lines/background-dots-lines-2.jpg`),
          srcMobile: '/img/home/line-bottom-2.svg',
          alt: 'puntos lineas',
        },
        list: [
          'Selecciona perfiles a partir de una base de datos que cuenta con más de 3.000 ocupaciones.',
          'Contrasta el talento existente en tu empresa con las nuevas ocupaciones del mercado.',
          'Calcula la coincidencia entre las ocupaciones actuales y las deseadas en tu empresa.',
          'Identifica las brechas de habilidades para cubrir esas nuevas ocupaciones.',
        ],
        button: {
          label: 'Descubre cómo lo hacemos',
          url: '/nuestra-propuesta',
        },
        isInvert: true,
      },
      {
        title: 'reconvierte tu fuerza laboral para los nuevos desafíos',
        img: {
          src: 'home-empresas-3',
          alt: 'reconvierte image',
        },
        imgBackground: {
          src: require(`~/assets/images/homepage/point-lines/background-dots-lg.jpg`),
          alt: 'puntos background',
        },
        list: [
          'Toma decisiones y construye trayectorias laborales atractivas basadas en evidencia.',
          'Planifica el desarrollo de habilidades para la especialización o reconversión de tus colaboradores.',
          'Diseña planes de capacitación pertinentes y acotados.',
          'Accede a planes de formación, cursos y capacitaciones usando Franquicia Tributaria de SENCE.',
        ],
        button: {
          label: 'Conoce más detalles',
          url: '/quienes-somos',
        },
      },
    ],

    cta: {
      title: 'Prepara a tu empresa para la transformación del mercado laboral',
      text:
        'Desde Relink acompañamos a tu empresa en este proceso, con herramientas especialmente diseñadas para apoyar la reconversión de su fuerza de trabajo.',
      link: {
        text: 'Solicita una reunión',
        url: '/agenda-una-reunion',
      },
    },
  },
  navBar: {
    navSecondary: {
      company: [
        {
          title: 'sobre relink',
          elements: [
            {
              label: 'Cómo funciona relink',
              link: '/como-funciona',
            },
          ],
        },
        {
          title: 'tienes dudas',
          elements: [
            {
              label: 'Preguntas frecuentes',
              link: '/preguntas-frecuentes',
            },
          ],
        },
      ],
      person: [
        {
          title: 'sobre relink',
          elements: [
            {
              label: 'Quiénes Somos',
              link: '/quienes-somos',
            },
            {
              label: 'Qué hacemos',
              link: '/nuestra-propuesta',
            },
          ],
        },
        {
          title: 'tienes dudas',
          elements: [
            {
              label: 'Preguntas frecuentes',
              link: '/preguntas-frecuentes',
            },
          ],
        },
      ],
    },
  },
  meetingRequest: {
    info: {
      title:
        '¡Accede a herramientas para gestionar las habilidades de tu organización!',
      description:
        'Completa los datos y obtén tu cuenta empresa en Relink. Esto te permitirá  utilizar funcionalidades de la plataforma para gestionar las habilidades de tus colaboradores de forma eficiente y segura.',
    },
    form: {
      alert: {
        message:
          'Estamos trabajando para habilitar este servicio en tu país. Déjanos tus datos y te informaremos tan pronto esté disponible.',
      },
      country: {
        label: 'País:',
        placeholder: 'Selecciona tu país',
        fieldName: 'país',
      },
      firstName: {
        label: 'Nombre:',
        fieldName: 'nombre',
      },
      lastName: {
        label: 'Apellidos:',
        fieldName: 'apellidos',
      },
      jobTitle: {
        label: 'Cargo:',
        fieldName: 'cargo',
      },
      company: {
        label: 'Empresa:',
        fieldName: 'empresa',
      },
      companyRut: {
        label: 'RUT empresa:',
        fieldName: 'RUT empresa',
      },
      email: {
        label: 'Correo electrónico:',
        fieldName: 'correo electrónico',
      },
      phone: {
        label: 'Teléfono (Opcional):',
        fieldName: 'teléfono',
      },
      terms: {
        first: 'He leído y acepto la',
        second: ' Política de uso de datos de empresas por parte de RELINK',
        third: '',
      },
      subscribe:
        'Quiero recibir las novedades de Relink en mi correo electrónico.',
      submit: 'Enviar',
    },
    modalConfirmation: {
      localCompany: {
        title: '¡Solicitud enviada con éxito!',
        description:
          'En las próximas 24 horas te contactaremos para completar la habilitación de tu cuenta. Si realizaste esta petición durante el fin de semana o en un día festivo en Chile, te contactaremos el día hábil siguiente a la realización de tu solicitud.',
      },
      foreignCompany: {
        title: '¡Registro completo!',
        description:
          'Hemos recibido tu información y te notificaremos en cuanto el servicio esté disponible en tu país. ¡Gracias por tu interés en Relink!',
      },
    },
  },
  publicFooter: {
    logos: {
      title: 'Un proyecto de:',
    },
    description:
      'Identifica las habilidades y desarrolla el potencial de tu equipo',
    aboutRelink: 'Sobre Relink',
    help: '¿Tienes dudas?',
    about: 'Quiénes Somos',
    purpose: 'Qué hacemos',
    faqs: 'Preguntas Frecuentes',
    policies: 'Política de privacidad',
    policiesData: 'Política de tratamiento de datos',
  },
  about: {
    title: 'Los desafíos que nos mueven',
    elements: [
      '<b>Facilitar</b> la empleabilidad de las personas y reducir el desempleo.',
      '<b>Contribuir</b> a enfocar adecuadamente los esfuerzos de capacitación en las empresas.',
      '<b>Fortalecer</b> el desarrollo de nuestro país mediante información confiable para incidir en la creación de políticas públicas que renueven la visión del mercado laboral de Chile.',
      '<b>Acompañar</b> a las empresas en el proceso de transformación del mercado laboral.',
      '<b>Orientar</b> el enfoque de las capacitaciones y el uso de recursos para los nuevos requerimientos de habilidades.',
      '<b>Potenciar</b> la reinserción laboral de las personas en un contexto de cambio.',
    ],
    infoMain: {
      title: 'Somos una respuesta a la transformación del mercado laboral.',
      description:
        'La revolución digital en curso está modificando la forma en que vivimos, nos relacionamos y trabajamos. En los próximos años algunos trabajos se transformarán, mientras que nuevas ocupaciones ya están surgiendo. En Relink queremos acompañar en este recorrido a personas, empresas y organizaciones en los ámbitos que ya están siendo afectados por este cambio.',
      action: 'Conoce más',
    },
    pageProposal: {
      title: 'Te conectamos con el futuro del trabajo',
      description:
        'A través de la plataforma de Relink y sus algoritmos, buscamos modernizar los sistemas de identificación de habilidades y el reconocimiento del potencial laboral de las personas, conciliando las necesidades de empresas, trabajadores y el Estado.',
      nuxtLink: 'Nuestra Propuesta',
    },
    stats: {
      stat1: {
        value: '2.200.000',
        description:
          'nuevos puestos, que <br/> exigirán habilidades <br/> actualizadas, serán creados',
      },
      stat2: {
        value: '+100',
        description: 'perfiles de empleo definidos',
      },
      stat3: {
        value: '+13.000',
        description: 'habilidades identificadas',
      },
      stat4: {
        value: '28',
        description: 'empresas trabajando <br/> junto a Relink',
      },
    },
  },
  proposal: {
    cards: [
      {
        isInverted: false,
        image: {
          src: 'img-card-1',
          alt: 'worker',
        },
        title: 'Usamos tecnología',
        description:
          'Simplificamos y escalamos los procesos de análisis de habilidades para el desarrollo de las empresas y las personas.',
      },
      {
        isInverted: true,
        image: {
          src: 'img-card-2',
          alt: 'worker',
        },
        title: 'Nos adaptamos a los sectores',
        description:
          'Damos respuestas innovadoras con foco en los perfiles ocupacionales que se necesitan en los diferentes sectores productivos.',
      },
      {
        isInverted: false,
        image: {
          src: 'img-card-3',
          alt: 'worker',
        },
        title: 'Acompañamos y orientamos',
        description:
          'Acompañamos a nuestros clientes con el fin de que tomen decisiones asertivas, focalizadas y basadas en evidencia para el futuro laboral de sus colaboradores.',
      },
    ],
    features: {
      title: 'Relink está acompañando esta transición en ocho áreas',
      elements: {
        digital: {
          title: 'Digital',
          description:
            'Desarrollo de softwares y plataformas digitales, gestión de servicios y arquitectura TI.',
        },
        maintenance: {
          title: 'Mantenimiento',
          description:
            'Instalación y mantenimiento de equipos y fabricación de partes y piezas para esos equipos, con mirada 4.0.',
        },
        logistic: {
          title: 'Logística',
          description:
            'Operaciones de despacho y recepción de productos, administración y coordinación de flotas, con mirada 4.0.',
        },
        supermarket: {
          title: 'Supermercado',
          description:
            'Procesos de comercialización de productos en supermercados, con el impacto de la transformación digital.',
        },
        manufacture: {
          title: 'Manufactura avanzada',
          description:
            'Procesos de manufactura con uso de tecnologías 4.0 (IoT, Big Data, IA, sistemas ciberfísicos).',
        },
        telecom: {
          title: 'Telecomunicaciones',
          description:
            'Conectividad en zonas remotas, Internet de las Cosas (IoT), big data, fenómeno Cloud.',
        },
        aeronautics: {
          title: 'Aeronautica',
          description:
            'Procesos de mantenimiento avanzado para las operaciones de vuelo y tierra en la industria aeronáutica.',
        },
        creative: {
          title: 'Creativa',
          description:
            'Diseño, creación y distribución de contenidos del entretenimiento con fuerte foco digital y tecnológico.',
        },
      },
    },
    secondaryInfo: {
      title: 'Transición laboral inteligente',
      elements: [
        {
          text:
            'Con el objetivo de promover oportunidades reales de desarrollo para los trabajadores, empresas y colaboradores, Relink combina información sobre los requerimientos del mercado laboral actual, la proyección de la demanda por nuevas habilidades, y la trayectoria laboral de las personas.',
        },
        {
          text:
            'Relink entrega orientaciones específicas a cada trabajador, empresa y organización, para que puedan definir rutas de desarrollos y capacitación que les permitan aprovechar las nuevas oportunidades laborales.',
        },
      ],
    },
  },
  policies: {
    introduction: [
      'RELINK es una iniciativa público-privado compuesta por el Servicio Nacional de Capacitación y Empleo (SENCE), Subsecretaría del Trabajo, Corporación de Capacitación y Empleo SOFOFA (Corporación SOFOFA), SOFOFA asociación gremial y el Banco Interamericano de Desarrollo (BID).',
      'Esta Política de Privacidad (la “Política”) explica cómo recopilamos y tratamos los Datos Personales recogidos con ocasión del acceso y uso de Relink ( accesible a través del sitio www.relink.cl, la “Plataforma”), qué datos personales se recogen, con quiénes se pueden compartir estos datos y cuáles son los derechos de los Usuarios como titulares de datos.',
      'Al aceptar esta Política, declaras que:',
      {
        list: true,
        items: [
          '- los datos personales proporcionados te pertenecen, están actualizados y son veraces; y',
          '- eres mayor de 18 años o que, siendo menor de 18 y mayor de 14, cuentas con la autorización de tus padres o por quien tiene a su cargo tu cuidado personal.',
        ],
      },
      'Los términos usados con mayúscula y no definidos en esta Política tendrán el significado que se les dé en los Términos y Condiciones de la Plataforma Relink.',
    ],
    items: [
      {
        subtitle: '1. Responsable de los Datos Personales',
        sections: [
          'El responsable del tratamiento de los Datos Personales recolectados con ocasión del acceso y uso de la Plataforma (los “Datos Personales”) es Corporación SOFOFA (el “Responsable”).',
          'Nuestros datos de identificación son los siguientes: ',
          {
            list: true,
            items: [
              '- Razón social:  Corporación de Capacitación y Empleo SOFOFA',
              '- Rol Único Tributario: 70.417.500-0',
              '- Domicilio: Agustinas 1357 pisos 11 y 12 Santiago Centro',
              '- Representante legal: Cristóbal Philippi Irarrázaval',
              '- Correo electrónico: [otic@oticsofofa.cl]',
              '- Teléfono: [2 23362800]',
            ],
          },
          '',
        ],
      },
      {
        subtitle: '2. Base de licitud del tratamiento de Datos Personales',
        sections: [
          'La base de licitud para el tratamiento de tus Datos Personales será, por regla general, el consentimiento que has otorgado al aceptar la presente Política. La autorización que nos entregas para tratar tus Datos Personales se extiende estrictamente a los propósitos y condiciones explicados en esta Política. ',
          'Cuando debamos cumplir con obligaciones legales o requerimientos de una autoridad, nuestra base de licitud será la autorización legal y, en tal caso, no necesitaremos de tu consentimiento para tratar los Datos Personales. No obstante, trataremos tus datos siempre en coherencia con la finalidad de tal autorización u obligación legal.',
        ],
      },
      {
        subtitle: '3. Fuentes de los Datos Personales recopilados',
        sections: [
          'Por regla general, tratamos Datos Personales proporcionados directamente por ti y/o derivados de tus interacciones con nosotros o la Plataforma. De esta forma, existirán dos tipos de recopilación:',
          'A. Mecanismos automáticos: procesos informáticos realizados para generar registros de las actividades de los visitantes de sitios web y cuyo objeto es establecer patrones de actividad, navegación y audiencia, que no implican la identificación personal de aquellos suscriptores, usuarios y/o visitantes que accedan a www.relink.cl ni asociación, directa o indirecta, a la información que de ellos se colecta ni a persona identificada o identificable. Dado lo anterior, Relink se reserva el derecho de usar dicha información agregada y estadística con la finalidad exclusiva de establecer criterios que mejoren su contenido y permita difundir la iniciativa.',
          'B. Mecanismos manuales: requerimientos formales y expresos de información a los usuarios, postulantes y/o visitantes del portal que implican recolección de datos u otra forma de tratamiento, como nombre, apellidos, datos de contacto y ubicación, ocupación, etc. Para estos casos se solicita consentimiento expreso y escrito de los titulares de la información, indicándoseles la finalidad para la cual sus datos personales están siendo solicitados.',
        ],
      },
      {
        subtitle: '4. Datos Personales tratados',
        sections: [
          'Trataremos los Datos Personales proporcionados directamente por ti y/o derivados de tus interacciones con nosotros o la Plataforma. ',
          'En particular, los Datos Personales que recolectamos y tratamos acerca de ti son los siguientes:',
          {
            list: true,
            items: [
              'a) <b>Datos de identificación</b>, como nombres, apellidos, R.U.T., fecha de nacimiento y género.',
              'b) <b>Datos de contacto,</b> como correo electrónico laboral o personal.',
              'c) <b>Datos acerca de tu ubicación o residencia,</b> como país, comuna y región.',
              'd) <b>Credenciales de acceso</b> a tu Perfil, como correo electrónico y contraseña.',
              'e) <b>Información de tu experiencia laboral,</b> incluyendo cargos que has desempeñado, su tiempo, nombre y rubro de las empresas para las cuales has trabajado, y las habilidades asociadas a tu experiencia laboral.',
              'f) <b>Información de tu experiencia formativa</b> como, por ejemplo, nivel educacional, información sobre los tipos de estudios que has realizado o estás realizando, incluyendo en cada caso lugar de estudio, área de estudio, su estado y habilidades asociadas a tu experiencia formativa.',
              'g) <b>Información sobre otras experiencias</b> que consideres relevantes para tu desarrollo profesional como, por ejemplo, voluntariados y actividades extracurriculares, incluyendo su duración y las habilidades asociadas a tal experiencia.',
              'h) <b>Información sobre tus habilidades</b> que decides registrar en tu Perfil.',
              'i) <b>Información sobre el uso que haces de la Plataforma,</b> como la hora de acceso, detalle de la navegación o alcance y cantidad de descargas.',
              'j) <b>Información sobre el dispositivo electrónico</b> desde el cual accedes, como tipo de dispositivo, sistema operativo, ubicación, estado de red, acceso a conectividad y nivel de batería.',
              'k) <b>Información que recopilamos de tus comunicaciones con nosotros</b> como, por ejemplo, cuando nos contactas directamente para ingresar consultas, sugerencias o reclamos.',
              'l) <b>Otros antecedentes</b> que nos entregues voluntariamente o que recopilemos legalmente o cuyo tratamiento sea autorizado por ley.',
            ],
          },
          'Te pedimos mantenernos informados respecto de cualquier corrección, actualización o ajuste que debamos hacer sobre tus Datos Personales al correo contacto@relink.cl. Mientras no nos comuniques expresamente lo contrario, entenderemos que tus Datos Personales no han experimentado modificaciones. ',
        ],
      },
      {
        subtitle: '5. Propósitos del tratamiento de datos',
        sections: [
          'Cuando das tu consentimiento expreso y escrito mediante la aceptación de esta Política, tus Datos Personales son tratados para los siguientes propósitos:',
          {
            list: true,
            items: [
              'a) Crear y administrar tu Perfil en la Plataforma.',
              'b) Gestionar el uso que haces de la Plataforma y sus distintas funcionalidades. Con este fin, usaremos algoritmos y realizaremos trabajos de analítica de tus datos que sean necesarios (p.ej. para entregarte el reporte con las ocupaciones de futuro que más se acerquen a tu perfil).',
              'c) Enviarte comunicaciones relacionadas con el uso de la Plataforma como, por ejemplo, notificarte de cambios en los Términos y Condiciones o en esta Política de Privacidad.',
              'd) Evaluar y mejorar la Plataforma, incluyendo la incorporación o desarrollo de nuevas funcionalidades. Con este fin, podremos realizar trabajos de analítica de tus datos.',
              'e) Atender y responder tus consultas, reclamos o sugerencias.',
              'f) Proteger los intereses legítimos del Responsable como, por ejemplo, implementar medidas de seguridad para el uso de la Plataforma y prevenir, detectar e investigar actividades prohibidas o ilegales que se desplieguen en relación con la operación de la Plataforma.',
              'g) Para fines de reestructuración corporativa, en el caso de una transferencia del negocio, o de fusiones, adquisiciones u otro tipo de reorganización corporativa, lo que incluye comunicar tus datos a la persona jurídica que en un proceso de due diligence evalúe la adquisición, y a la persona jurídica que adquiera los activos o sea sucesora del Responsable.',
              'h) Anonimizar tus Datos Personales, de manera tal que, luego de este proceso de anonimización, ya no permitan tu identificación. Una vez que tus datos sean anonimizados, ya no estarán sujetos a esta Política ni a la legislación de protección de datos aplicable.',
            ],
          },
          'Además, si das tu consentimiento mediante la aceptación de una casilla distinta a la de aceptación de esta Política, podremos enviarte novedades y, en general, comunicaciones de marketing de la Plataforma y, en general, de las diversas iniciativas, productos o servicios relacionados con la plataforma. Siempre podrás solicitarnos que dejemos de enviarte comunicaciones de marketing.',
          'Finalmente, podremos tratar tus Datos Personales cuando sea necesario para cumplir con obligaciones legales y reglamentarias.',
        ],
      },
      {
        subtitle: '6. Comunicación de Datos Personales a terceros',
        sections: [
          'La comunicación de tus Datos Personales se limita a lo establecido expresamente en esta Política. En este sentido, podemos comunicar o ceder tus Datos Personales a entidades ubicadas en Chile o en el extranjero, en los siguientes casos:',
          {
            list: true,
            items: [
              'a) Proveedores. Podemos comunicar sus Datos Personales a nuestros proveedores de servicios, quienes tratarán sus datos en calidad de mandatarios y para el sólo efecto de prestarnos el servicio para el cual han sido contratados. Dentro de estos proveedores se encuentran:',
              '&emsp; - Proveedores de servicios de tecnología (p.ej. el proveedor a cargo de mantener el sitio web en el que está alojada la Plataforma).',
              '&emsp; - Proveedores de servicio a cargo de la gestión de uno o más aspectos de la Plataforma.',
              '&emsp; - Proveedores de servicios de almacenamiento en la nube. ',
              'b) Ofertas laborales. Podemos transmitir tus Datos Personales a instituciones o empresas que buscan candidatos que se pueden adecuar a tu perfil. Estas instituciones podrán, si lo desean, contactarte en caso de una oferta laboral. Si no quieres que transfiramos tus datos a estas instituciones, puedes ir a la sección “Mi Perfil” y desmarcar esta opción.  Estos terceros tratarán tus datos como responsable de datos. ',
              'c) Autoridades y otros terceros. Podremos transmitir tus Datos Personales a autoridades regulatorias, judiciales o administrativas, o a otros terceros, cuando sea necesario para cumplir con obligaciones legales, reglamentarias, u órdenes de la autoridad. El tratamiento realizado por estas autoridades o terceros una vez que le comuniquemos tus datos, será responsabilidad de aquellas entidades.',
              'd) Ministerio del Trabajo y organismos relacionados. Podremos transmitir tus Datos Personales al Ministerio del Trabajo y sus organismos relacionados para su uso de acuerdo con sus competencias. El tratamiento realizado por estas instituciones una vez que le comuniquemos tus datos, será responsabilidad de aquellas entidades.',
            ],
          },
          '',
        ],
      },
      {
        subtitle:
          '7. Derechos de los Usuarios como titular de Datos Personales',
        sections: [
          'Como titular de Datos Personales, tienes los siguientes derechos:',
          {
            list: true,
            items: [
              '- <b>Acceso:</b> Obtener confirmación acerca de si el Responsable está tratando sus Datos Personales, y en la afirmativa acceder a éstos, conocer su procedencia y destinatarios (si hubiere) y el propósito del almacenamiento.',
              '- <b>Rectificación:</b> Obtener que se modifiquen sus datos inexactos, equívocos o incompletos.',
              '- <b>Bloqueo:</b> Obtener la suspensión temporal de cualquier tratamiento de datos, con excepción del almacenamiento.',
              '- <b>Cancelación:</b> Obtener la eliminación de los Datos Personales cuando se encuentren caducos o su tratamiento carezca de fundamento legal.',
            ],
          },
          'También siempre puedes revocar tu consentimiento, sin efecto retroactivo. En tal escenario, como en el de solicitud de eliminación o bloqueo de tus datos, al ser el tratamiento de tus datos un elemento esencial para el funcionamiento de la Plataforma, quedarás excluido de esta.',
          'Para ejercer estos derechos como titular de datos o ante cualquier duda sobre esta Política de Privacidad, puedes enviar un correo electrónico a contacto@relink.cl señalando tu petición específica. Corporación SOFOFA se reserva la facultad de requerir razonablemente que verifiques tu identidad antes de responder el fondo de la solicitud. ',
        ],
      },
      {
        subtitle: '8. Conservación de los Datos Personales',
        sections: [
          'Tus Datos Personales serán tratados durante todo el tiempo que sea necesario para cumplir con las finalidades indicadas en esta Política, salvo que alguna ley aplicable nos obligue a retenerlos por un período superior. De esta manera, almacenaremos y trataremos tus Datos Personales mientras mantengas una cuenta en la Plataforma. Luego de ello, no almacenaremos tus Datos Personales por un período superior al plazo de prescripción de las acciones legales que puedan derivar de su uso. Transcurridos estos plazos, eliminaremos tus Datos Personales, o los anonimizaremos.',
        ],
      },
      {
        subtitle: '9. Medidas de protección ',
        sections: [
          'Corporación SOFOFA mantiene, en conformidad con la legislación vigente, medidas de protección organizativas, administrativas, técnicas y físicas apropiadas y especialmente diseñadas para proteger sus Datos Personales contra la destrucción, pérdida, alteración, acceso, revelación o uso accidental, ilegal o no autorizado. Sin perjuicio de lo anterior, debido a la naturaleza de Internet, la seguridad de la transmisión de información nunca puede ser garantizada en su totalidad, sin perjuicio que Corporación SOFOFA en todo momento hará sus mejores esfuerzos por mantener dicha información segura.',
        ],
      },
      {
        subtitle: '10. Modificaciones',
        sections: [
          'En caso de existir cambios o modificaciones a esta Política, pondremos a tu disposición la versión actualizada por el mismo medio por el que se dio a conocer. Si los cambios se refieren al tratamiento de tus Datos Personales con fines distintos a los señalados, o la comunicación a terceros diferentes a los indicados, solicitaremos nuevamente tu consentimiento.',
        ],
      },
    ],
    final: {
      subtitle: '',
      sections: ['Versión 2.0, actualizada por primera vez en julio de 2023'],
    },
  },
  months: [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Setiembre',
    'Octubre',
    'Noviembre',
    'Diciembre',
  ],
  roles: {
    EMPLOYEE: 'Empleado',
    RELINK: 'Relink',
    UNEMPLOYED: 'Desempleado',
    COMPANY: 'Empresa',
    PUBLIC: 'Público',
  },
  testResult: {
    LOW: {
      value: 'BAJO',
      description:
        'Capaces de utilizar herramientas y equipos simples, trabajos rutinarios que no requieran de comprensiones complejas. Capaces de trabajar bajo supervisión permanente.',
    },
    MEDIUM_LOW: {
      value: 'MEDIO BAJO',
      description:
        'Requieren de mayor tiempo para aprender, deben ser bien capacitados antes de asignarles alguna tarea; pueden realizar operaciones simples y para solucionar problemas requieren de ayuda. Toman decisiones en ámbitos limitados y tienen éxito en situaciones elementales.',
    },
    MEDIUM: {
      value: 'MEDIO',
      description:
        'Capaces de aprender rutinas de trabajo rápidamente, usando una combinación de materiales escritos y experiencias de trabajo real. Piden ayuda para resolver problemas y tomar decisiones.',
    },
    MEDIUM_HIGH: {
      value: 'MEDIO ALTO',
      description:
        'Tienen capacidad para aprender por su cuenta, puede recopilar información para tomar decisiones con poca ayuda. Tienen buena capacidad para analizar problemas con un número limitado de alternativas.',
    },
    HIGH: {
      value: 'ALTO',
      description:
        'Personas capaces de aprender mucho por sí mismos, tienen un alto potencial gerencial y para cargos de jefaturas a nivel superior. Manejan información, analizan y toman decisiones a partir de alternativas limitadas.',
    },
    VERY_HIGH: {
      value: 'MUY ALTO',
      description:
        'Personas capaces de reunir y sintetizar información fácilmente, pueden inferir información y llegar a conclusiones sobre situaciones de trabajo, poseen excelente habilidad para solucionar problemas, aprendizaje más rápido, tienen mucha facilidad para tomar decisiones cuando falta información.',
    },
  },
  test: {
    messageIncomplete:
      'Debes completar tus datos personales para acceder al test de habilidades.',
    messageProgress:
      'Tu test de habilidades esta siendo procesado, en el caso de que no lo hayas finalizado puedes volver a contestarlo mañana.',
    messageComplete:
      'Tu test de habilidades ha sido procesado y completado exitosamente.',
    goProfile: 'Ir a mi perfil',
    goHome: 'Ir a inicio',
    yourScore: 'Tu puntaje obtenido fue de: ',
  },
  configuration: {
    title: 'Configuración y privacidad',
    WORKER_MININUM_DISTANCE: {
      title: 'Porcentaje de corte match',
      description:
        'Ajustar porcentaje de corte match para todas las ocupaciones requeridas por la empresa.',
      valueDescription:
        'Solo números entre el 0 y 99 (no paréntesis, guiones o espacios).',
    },
  },
  modeRegister: {
    RELINK: 'Relink.cl',
    INVITATION: 'Invitado',
  },
  jobSeekerFair: {
    status: { open: 'Abierta', close: 'Cerrada' },
    potentialsUser: {
      tabs: {
        laboralMatch: 'Coincidencias candidato-ocupaciones',
        experiences: 'Experiencias',
        skills: 'Habilidades desarrolladas',
        personalData: 'Información personal',
      },
      table: {
        laboralExperiences: 'Experiencias laborales',
        formativeExperiences: 'Experiencias formativas',
        organization: 'Organización',
        period: 'Período',
        present: 'al presente',
        skills: 'Habilidades desarrolladas',
        experience: 'Experiencia',
        type: 'Tipo',
        status: 'Estado',
        matchDefault: 'Otros',
        studyLocation: 'Lugar de Estudios',
        workSkill: 'Laboral',
        educationSkill: 'Formativa',
        employed: 'Empleado',
        unemployed: 'No registra ocupación a la fecha',
      },
    },
  },
  notProvideData: {
    title: 'Queremos conocerte :)',
    description:
      'Mantén activa la opción de "Brindar datos de mi perfil", así las instituciones ligadas a Relink que buscan candidatos pueden encontrar información sobre tu perfil y contactarte.',
    button: 'Ir a Mi Perfil',
  },
  freeSkills: {
    header: {
      title: '¡Ya estamos casi!',
      subtitle_default:
        '¿Nos faltó preguntarte alguna habilidad que aplicaste?',
      subtitle_middle_education:
        'Todavia puedes agregar habilidades adicionales a esta experiencia',
    },
    suggest: {
      title: 'Habilidades sugeridas en función de tu experiencia:',
    },
    search: {
      title: 'O puedes ingresarlas directamente:',
      titleOptional: 'Puedes ingresarlas directamente:',
      subtitle:
        'Escribe una palabra simple o compuesta. Ej: realizar cálculos matemáticos, desarrollar ideas creativas, estadística básica, preparar informes periódicos.',
    },
  },
  freeSkillsOthers: {
    header: {
      title: 'Añadir Habilidades',
      subtitle_main: 'Recomendación:',
      subtitle_description:
        'Incluye como mínimo entre 10 y 15 de tus habilidades principales para destacarte.',
    },
    search: {
      title: 'Agregar una nueva habilidad:',
      subtitle:
        'Escribe una palabra simple o compuesta. Ej: archivar documentos',
    },
  },
  confirmEmailModal: {
    header: {
      title: '¡Aviso!',
      subtitle_main: 'Recuerde verificar su correo electrónico',
      subtitle_description:
        'Asegúrese de verificar tu correo electrónico para activar su cuenta en Relink. Puede solicitar un nuevo enlace de confirmación a continuación.',
    },
    footer: {
      buttonCta: 'Enviar enlace',
    },
  },
  successEmailPasswordResetModal: {
    header: {
      subtitle_description:
        'En breve recibirás un mensaje en tu Correo Electrónico para poder crear tu nueva contraseña',
    },
  },
  questionaries: {
    breadcrumb: 'Cuestionario',
    instructive: {
      title: '¡Te damos la bienvenida!',
      subtitle:
        'El propósito de este cuestionario es que puedas responder algunas preguntas adicionales sobre las habilidades que has desplegado en tu experiencia laboral.',
      occupationSubtitle:
        'El propósito de este cuestionario es conocerte mejor y que valides tus habilidades para que podamos ayudarte a alcanzar tu máximo potencial.',
      kitOfSkillsSubtitle:
        'El propósito de este cuestionario es que puedas responder algunas preguntas sobre las habilidades que has desplegado en tu experiencia profesional',
      about: {
        title: 'Sobre el cuestionario:',
        list: {
          item1:
            'Queremos conocerte mejor, así que sé sincero y no te preocupes,',
          bold1: 'esto no es una evaluación.',
          item2:
            'Tendrás un número limitado de preguntas que dependerá de tus respuestas.',
          item3: 'Asegúrate de comprender bien las instrucciones.',
          item4: 'Cada pregunta solo te tomará alrededor de 1,5 minutos.',
        },
      },
      tips: {
        title: 'Algunos consejos antes de comenzar:',
        subtitle:
          'Tómate unos minutos para leer la siguiente información que te será de ayuda para el siguiente cuestionario.',
        list: {
          item1: 'Te recomendamos buscar un lugar cómodo y tranquilo.',
          item2: 'Comprueba que tu conexión de internet sea estable.',
          item3:
            'Si cerraste el proceso antes de terminar, ¡no te preocupes! Puedes continuar nuevamente desde donde lo dejaste sin ningún problema.',
        },
      },
    },
    questionary: {
      title: '¡Hola, {0}!',
      subtitleCompany:
        'Nos gustaría conocer sobre tu experiencia. <b>Selecciona tu cargo actual en la empresa:</b>',
      subtitleCollege:
        'Nos gustaría conocer sobre tu experiencia. <b>Cuéntanos ¿Qué estás estudiando?</b>',
      buttonBack: 'Anterior',
      buttonNext: 'Siguiente',
      alert: {
        main:
          'Antes de continuar con el cuestionario, verifica que tu elección sea la correcta, ',
        text:
          'porque una vez que empieces, no podrás modificarla más adelante.',
      },
    },
  },
  reports: {
    home: 'Home',
    title: 'Informes sectoriales',
    download: 'Descargar',
    description:
      'En un mercado laboral en constante transformación, contar con información actualizada es esencial. Por ello, Relink ha liderado el desarrollo de diversos informes sectoriales en colaboración con organizaciones y actores clave de varias industrias, con el fin de identificar y diseñar perfiles ocupacionales y agrupaciones de habilidades futuras.',
  },
  generalReport: {
    breadcrumb: 'Reporte general',
    title: '¡Bienvenido a tu Reporte General!',
    description:
      'En el Reporte General podrás visualizar el estado de tus proyectos y la actividad de tus colaboradores. Además, podrás interactuar con estos contenidos.',
    cards: {
      totalUsers: {
        title: 'Usuarios totales',
        label: 'Cantidad de personas de tu organización en la plataforma',
        description: 'A la actualidad',
      },
      averageExperiences: {
        title: 'Promedio experiencias',
        label:
          'Promedio experiencias registradas por los integrantes de tu organización',
      },
      averageSkills: {
        title: 'Promedio Habilidades',
        label:
          'Promedio de habilidades registradas por los integrantes de tu organización',
      },
      onGoingProjectsTable: {
        title: 'Proyectos en curso',
        label: 'Resumen del estado de los proyectos activos',
      },
      topSkillsTable: {
        title: 'Top 10 habilidades más reconocidas',
        label:
          'Descubre las habilidades que más repiten las personas de tu organización',
      },
    },
  },
}
